// import React, { useState, useEffect } from 'react';

// import {

//   AppBar,

//   Toolbar,

//   Button,

//   TextField,

//   Container,

//   Typography,

//   Grid,

//   Card,

//   CardContent,

//   Select,

//   Box,

//   FormControl,

//   MenuItem,

//   InputLabel,

//   styled,

//   Table,

//   TableBody,

//   TableCell,

//   List,

//   ListItem,

//   ListItemText,

//   TableRow,

//   Collapse

// } from '@mui/material';

// import { createTheme, ThemeProvider } from '@mui/material/styles';

// import TDTLLogo from "./landpageimage1/TDTLLogo.png"

// import LightbulbIcon from '@mui/icons-material/Lightbulb';

// import { ReactTyped as Typed } from 'react-typed';

// import { motion } from 'framer-motion';

// import { Swiper, SwiperSlide } from 'swiper/react';

// import 'swiper/css';

// import MenuBookIcon from '@mui/icons-material/MenuBook';

// import PublicIcon from '@mui/icons-material/Public';

// import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

// import AddIcon from '@mui/icons-material/Add';

// import RemoveIcon from '@mui/icons-material/Remove';

// import DYPLogo from './landpageimage/DYPLogo.png';

// import ElphantTankLogo from './landpageimage/elephanttanklogo.png';

// import Chatbotimage from './landpageimage1/Bot.png';

// import Swal from 'sweetalert2';

// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// import {  Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

// import { Pagination, Autoplay} from 'swiper/modules';

 

 

// import pana from './landpageimage1/pana.png';

// import ElephantTank from './landpageimage1/ElephantTank.png';

// import GetAttachmentThumbnail from './landpageimage1/GetAttachmentThumbnail.png';

// import Tdtllogo from './landpageimage/TDTLLogo.png';

// import { Link as ScrollLink } from 'react-scroll';

// import { useNavigate } from 'react-router-dom';

// import J4E from './landpageimage/logo2.jpg'

// import { Link } from 'react-router-dom';

// import v1 from './video/v1.mp4'

// import v2 from './video/v2.mp4'

// import v3 from './video/v3.mp4'

// import v4 from './video/v4.mp4'

// import sampleVideo from './video/invideo-ai-1080 Transform Your Ideas into Reality with E 2024-12-22.mp4'

// import p1 from './landpageimage/discarded-idea/p1.svg'

// import p2 from './landpageimage/pana.png'

// import p3 from './landpageimage/rafiki.png'

// import p4 from './landpageimage/cuate.png'

// import p5 from './landpageimage/Group 1000001937.png'

// import p6 from './landpageimage/CubeLeft.png'

// import p7 from './landpageimage/CubeRight.png'

// import c1 from './landpageimage/Clip path group-1.png'

// import c2 from './landpageimage/Clip path group-2.png'

// import c3 from './landpageimage/Ellipse 4.png'

// import c4 from './landpageimage/Ellipse 6.png'

// import c5 from './landpageimage/Circle.png'

// import c6 from './landpageimage/Circle.png'

 

 

 

// import {

//   Facebook,

//   LinkedIn,

//   Twitter,

//   Instagram,

//   WhatsApp,

// } from '@mui/icons-material';

// import robo from './landpageimage/Bot.png'

// import {  Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

// import EmailIcon from '@mui/icons-material/Email';

// import PhoneIcon from '@mui/icons-material/Phone';

// import LocationOnIcon from '@mui/icons-material/LocationOn';

// import {

//   LaptopMac as LaptopIcon,

//   PresentToAll as PresentationIcon,

//   CheckCircle as CheckCircleIcon,

//   School as SchoolIcon

// } from '@mui/icons-material';

 

// const GradientBox = styled(Box)(({ theme }) => ({

//   position: 'absolute',

//   inset: 0,

//   background: 'linear-gradient(180deg, rgba(88, 28, 135, 0.2) 0%, transparent 100%)',

//   pointerEvents: 'none',

// }));

// function getCurrentDate() {

//   const options = { year: "numeric", month: "long", day: "numeric" };

//   return new Date().toLocaleDateString("en-US", options);

// }

 

 

 

// const StyledCard = styled(Card)(({ theme }) => ({

//   background: 'rgba(88, 28, 135, 0.15)',

//   backdropFilter: 'blur(20px)',

//   border: '1px solid rgba(147, 51, 234, 0.2)',

//   borderRadius: theme.shape.borderRadius * 2,

//   color: '#fff',

//   height: '100%',

//   transition: 'all 0.3s ease',

//   '&:hover': {

//     transform: 'translateY(-5px)',

//     boxShadow: '0 8px 30px rgba(147, 51, 234, 0.2)'

//   }

// }));

 

// const FloatingCube = styled('img')(({ theme, index }) => ({

//   position: 'absolute',

//   width: '100px',

//   height: '100px',

//   opacity: 0.5,

//   animation: `float ${2 + index * 0.5}s ease-in-out infinite alternate`,

//   left: index % 2 === 0 ? '25%' : '75%',

//   top: index < 2 ? '25%' : index < 4 ? '50%' : '75%',

//   '@keyframes float': {

//     '0%': {

//       transform: 'translateY(0px) rotate(0deg)',

//     },

//     '100%': {

//       transform: `translateY(${20 + index * 5}px) rotate(${5 + index * 2}deg)`,

//     },

//   },

// }));

 

// const StarIcon = styled('div')(({ theme }) => ({

//   width: '40px',

//   height: '40px',

//   position: 'absolute',

//   opacity: 0.6,

//   '&::before, &::after': {

//     content: '""',

//     position: 'absolute',

//     background: 'white',

//     width: '2px',

//     height: '20px',

//     left: '50%',

//     top: '50%',

//     transform: 'translate(-50%, -50%)',

//   },

//   '&::after': {

//     transform: 'translate(-50%, -50%) rotate(90deg)',

//   },

//   animation: 'twinkle 1.5s ease-in-out infinite',

//   '@keyframes twinkle': {

//     '0%, 100%': { opacity: 0.6 },

//     '50%': { opacity: 1 },

//   }

// }));

 

// const ProcessCard = styled(Card)(({ theme }) => ({

//   background: 'rgba(255, 255, 255, 0.95)',

//   borderRadius: '24px',

//   overflow: 'hidden',

//   height: '100%',

//   transition: 'transform 0.3s ease-in-out',

//   '&:hover': {

//     transform: 'translateY(-8px)',

//   },

// }));

 

// const FAQTable = styled(Box)(({ theme }) => ({

//   background: 'rgba(255, 255, 255, 0.95)',

//   borderRadius: '24px',

//   overflow: 'hidden',

//   '& .MuiTableCell-root': {

//     borderColor: 'rgba(147, 51, 234, 0.1)',

//   },

// }));

 

// const theme = createTheme({

//   palette: {

//     mode: 'dark',

//     primary: {

//       main: '#9333EA',

//     },

//     background: {

//       default: '#0A0118',

//       paper: 'rgba(88, 28, 135, 0.2)',

//     },

//   },

// });

 

// function FAQSection() {

//   const [expandedRow, setExpandedRow] = useState(null);

 

//   const handleRowClick = (index) => {

//     setExpandedRow(expandedRow === index ? null : index);

//   };

 

//   const faqs = [

//     {

//       question: "Who Can Participate?",

//       answer:

//         "Any UG/PG Student with an innovative idea is welcome to join! Eligibility Criteria:\n• Undergraduate Students: Students from various disciplines such as BBA, B.Com, B.Sc., B.Tech/B.E., B.Arch, B.Pharm, BFA, and others (first to final year students are eligible to pitch their ideas).\n• Postgraduate Students: Participants enrolled in programs like MBA, MCA, PGDM, M.Pharm, M.Tech, M.Sc., M.Arch, and similar courses can also participate.",

//     },

//     {

//       question: "What is the Registration Fee?",

//       answer: "There is no registration fee for participating in the event.",

//     },

//     {

//       question: "Can I Participate in Both Events?",

//       answer:

//         "Yes, absolutely! We encourage participants to maximize their opportunities by joining both programs. You can pitch your idea in Elephant Tank and further develop it through the InnovateX internship program. Special combined registration options are also available.",

//     },

//     {

//       question: "Will I Be Able to Embed the Chatbot into My Website?",

//       answer:

//         "Yes, our platform offers easy integration for embedding chatbots into your website. We provide simple code snippets and detailed documentation to ensure seamless integration with your existing web infrastructure.",

//     },

//     {

//       question: "Can Multiple Team Members Manage My Chatbot?",

//       answer:

//         "Yes, we support multi-user chatbot management. You can assign roles and permissions to various team members, enabling collaborative management. Each team member will have their own login credentials while working on the same chatbot instance.",

//     },

//   ];

 

 

//   return (

//     <Container sx={{ py: 10 }}>

//       {/* FAQ Title */}

//       <Typography

//         variant="h2"

//         sx={{

//           color: 'white',

//           textAlign: 'center',

//           mb: 4,

//           fontSize: { xs: '2.5rem', md: '3.5rem' },

//           fontWeight: 'bold',

//           position: 'relative',

//           '&::after': {

//             content: '""',

//             position: 'absolute',

//             bottom: -16,

//             left: '50%',

//             transform: 'translateX(-50%)',

//             width: 100,

//             height: 4,

//             background: 'linear-gradient(90deg, transparent, #9333EA, transparent)',

//             borderRadius: 2,

//           },

//         }}

//       >

//         FAQ's

//       </Typography>

 

//       {/* FAQ Table */}

//       <Table>

//         <TableBody>

//           {faqs.map((faq, index) => (

//             <React.Fragment key={index}>

//               {/* Question Row */}

//               <TableRow

//                 onClick={() => handleRowClick(index)}

//                 sx={{

//                   cursor: 'pointer',

//                   '&:hover': {

//                     bgcolor: 'rgba(147, 51, 234, 0.05)',

//                   },

//                 }}

//               >

//                 <TableCell

//                   sx={{

//                     p: 3,

//                     display: 'flex',

//                     alignItems: 'center',

//                     justifyContent: 'space-between',

//                   }}

//                 >

//                   <Typography

//                     variant="h6"

//                     sx={{

//                       color: 'white',

//                       fontWeight: 'medium',

//                     }}

//                   >

//                     {index + 1}. {faq.question}

//                   </Typography>

//                   <Box

//                     sx={{

//                       width: 32,

//                       height: 32,

//                       display: 'flex',

//                       alignItems: 'center',

//                       justifyContent: 'center',

//                       borderRadius: '50%',

//                       bgcolor: expandedRow === index ? '#9333EA' : 'rgba(147, 51, 234, 0.1)',

//                       transition: 'all 0.3s ease',

//                     }}

//                   >

//                     {expandedRow === index ? (

//                       <RemoveIcon sx={{ color: expandedRow === index ? 'white' : '#9333EA' }} />

//                     ) : (

//                       <AddIcon sx={{ color: '#9333EA' }} />

//                     )}

//                   </Box>

//                 </TableCell>

//               </TableRow>

 

//               {/* Answer Row */}

//               <TableRow>

//                 <TableCell sx={{ p: 0, border: 'none' }}>

//                   <Collapse in={expandedRow === index}>

//                     <Box

//                       sx={{

//                         p: 3,

//                         pt: 0,

//                         color: 'white',

//                         bgcolor: 'rgba(255, 255, 255, 0.05)',

//                       }}

//                     >

//                       <Typography>{faq.answer}</Typography>

//                     </Box>

//                   </Collapse>

//                 </TableCell>

//               </TableRow>

//             </React.Fragment>

//           ))}

//         </TableBody>

//       </Table>

//     </Container>

//   );

// }

// const Footer = () => {

//   // State to manage form inputs

//   const [formData, setFormData] = useState({

//     fullName: '',

//     email: '',

//     phone: '',

//     message: '',

//   });

 

//   // Handle input changes

//   const handleInputChange = (e) => {

//     const { name, value } = e.target;

//     setFormData((prevData) => ({

//       ...prevData,

//       [name]: value,

//     }));

//   };

 

//   // Handle form submission

//   const handleFormSubmit = () => {

//     Swal.fire({

//       title: 'Thank You!',

//       text: 'Your enquiry has been submitted successfully.',

//       icon: 'success',

//       confirmButtonText: 'OK',

//       confirmButtonColor: '#7E22CE',

//     }).then(() => {

//       setFormData({

//         fullName: '',

//         email: '',

//         phone: '',

//         message: '',

//       });

//     });

//   };

 

//   return (

//     <Box sx={{ bgcolor: '#1A1A1A', color: 'white', pt: 4, pb: 4 }}>

//       <Container maxWidth="lg">

//       <Grid container spacing={3} justifyContent="space-between" alignItems="flex-start">

//   {/* Industries Column */}

//   {/* <Grid item xs={12} sm={6} md={3}>

//     <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>

//       INDUSTRIES

//     </Typography>

//     {['Banking & Financial Services', 'Energy & Commodities', 'Healthcare', 'Public Sector', 'Retail', 'Transportation & Mobility'].map((item) => (

//       <Typography

//         key={item}

//         sx={{

//           mb: 1.5,

//           color: 'rgba(255,255,255,0.7)',

//           display: 'flex',

//           alignItems: 'center',

//           gap: 1,

//           cursor: 'pointer',

//           '&:hover': { color: 'white' },

//         }}

//       >

//         <Box component="span" sx={{ fontSize: '0.8rem' }}>▶</Box>

//         {item}

//       </Typography>

//     ))}

//   </Grid> */}

 

//   {/* Services Column */}

//   {/* <Grid item xs={12} sm={6} md={3}>

//     <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>

//       SERVICES

//     </Typography>

//     {['Business Transformation', 'Digital Transformation', 'Learning Transformation', 'Technology Training Programs'].map((item) => (

//       <Typography

//         key={item}

//         sx={{

//           mb: 1.5,

//           color: 'rgba(255,255,255,0.7)',

//           display: 'flex',

//           alignItems: 'center',

//           gap: 1,

//           cursor: 'pointer',

//           '&:hover': { color: 'white' },

//         }}

//       >

//         <Box component="span" sx={{ fontSize: '0.8rem' }}>▶</Box>

//         {item}

//       </Typography>

//     ))}

//   </Grid> */}

 

//   {/* Quick Links Column */}

//   {/* <Grid item xs={12} sm={6} md={3}>

//     <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>

//       QUICK LINKS

//     </Typography>

//     {['Privacy Policy', 'Refund Policy', 'Terms & Conditions', 'Blogs'].map((item) => (

//       <Typography

//         key={item}

//         sx={{

//           mb: 1.5,

//           color: 'rgba(255,255,255,0.7)',

//           display: 'flex',

//           alignItems: 'center',

//           gap: 1,

//           cursor: 'pointer',

//           '&:hover': { color: 'white' },

//         }}

//       >

//         <Box component="span" sx={{ fontSize: '0.8rem' }}>▶</Box>

//         {item}

//       </Typography>

//     ))}

//   </Grid> */}

 

//   {/* Initiatives & Links */}

//   {/* <Grid item xs={12} sm={6} md={3}>

//     <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>

//       INITIATIVES

//     </Typography>

//     {['Panther Diaries', 'Sutradhar HR'].map((item) => (

//       <Typography

//         key={item}

//         sx={{

//           mb: 1.5,

//           color: 'rgba(255,255,255,0.7)',

//           display: 'flex',

//           alignItems: 'center',

//           gap: 1,

//           cursor: 'pointer',

//           '&:hover': { color: 'white' },

//         }}

//       >

//         <Box component="span" sx={{ fontSize: '0.8rem' }}>▶</Box>

//         {item}

//       </Typography>

//     ))}

 

  

//   </Grid> */}

// </Grid>

 

 

//         {/* Form Section */}

//         {/* <Box sx={{ mt: 8, textAlign: 'center' }}>

//   <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>

//     GET IN TOUCH, ENQUIRE NOW

//   </Typography>

//   <Grid container spacing={2} justifyContent="center">

//     <Grid item xs={12} sm={6} md={3}>

//     <TextField

//   fullWidth

//   placeholder="Full Name"

//   name="fullName"

//   type="text"

//   value={formData.fullName}

//   onChange={(e) => {

//     const regex = /^[A-Za-z\s]*$/; // Regex to allow only letters and spaces

//     if (regex.test(e.target.value)) {

//       handleInputChange(e); // Call your existing input handler only if valid

//     }

//   }}

//   sx={{

//     bgcolor: 'white',

//     borderRadius: 1,

//     '& .MuiOutlinedInput-root': {

//       '& fieldset': { borderColor: 'gray' },

//     },

//     '& .MuiInputBase-input': { color: 'black' },

//   }}

//   required

//   error={!formData.fullName}

// />

 

//     </Grid>

//     <Grid item xs={12} sm={6} md={3}>

//     <TextField
//   fullWidth
//   placeholder="Email"
//   name="email"
//   value={formData.email}
//   onChange={(e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));

//     // Inline email validation
//     if (name === 'email') {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       e.target.setCustomValidity(emailRegex.test(value) ? '' : 'Invalid email address');
//     }
//   }}
//   sx={{
//     bgcolor: 'white',
//     borderRadius: 1,
//     '& .MuiOutlinedInput-root': {
//       '& fieldset': { borderColor: 'gray' },
//     },
//     '& .MuiInputBase-input': { color: 'black' },
//   }}
//   required
//   error={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && formData.email.length > 0}
//   helperText={
//     !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && formData.email.length > 0
//       ? 'Please enter a valid email address'
//       : ''
//   }
// />


//     </Grid>

//     <Grid item xs={12} sm={6} md={3}>

//     <TextField

//   fullWidth

//   placeholder="Phone No."

//   name="phone"

//   value={formData.phone}

//   onChange={(e) => {

//     const regex = /^[0-9]*$/; // Allow only numeric input

//     if (regex.test(e.target.value) && e.target.value.length <= 10) {

//       handleInputChange(e); // Update the value only if it's valid

//     }

//   }}

//   sx={{

//     bgcolor: 'white',

//     borderRadius: 1,

//     '& .MuiOutlinedInput-root': {

//       '& fieldset': { borderColor: 'gray' },

//     },

//     '& .MuiInputBase-input': { color: 'black' },

//   }}

//   required

//   error={formData.phone.length !== 10}

  

// />

 

//     </Grid>

//     <Grid item xs={12} sm={6} md="auto">
//   <Button
//     variant="contained"
//     onClick={() => {
//       if (!formData.fullName || !formData.email || !formData.phone) {
//         Swal.fire({
//           title: 'Error!',
//           text: 'Please fill in all required fields.',
//           icon: 'error',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#d32f2f',
//         });
//         return;
//       }

//       handleFormSubmit();
//     }}
//     sx={{
//       bgcolor: '#7E22CE',
//       width: '200px', // Ensure consistent width
//       height: '55px', // Ensure consistent height
//       fontSize: '16px', // Optional: maintain readability
//       '&:hover': { bgcolor: '#6B21A8' },
//     }}
//   >
//     Submit
//   </Button>
// </Grid>


//   </Grid>

// </Box> */}

// <Box sx={{ mt: 8, textAlign: 'center' }}>
//   <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>
//     GET IN TOUCH, ENQUIRE NOW
//   </Typography>

//   <Grid container spacing={2} justifyContent="center">
//     <Grid item xs={12} sm={6} md={3}>
//       <TextField
//         fullWidth
//         placeholder="Full Name"
//         name="fullName"
//         type="text"
//         value={formData.fullName}
//         onChange={(e) => {
//           const regex = /^[A-Za-z\s]*$/; // Regex to allow only letters and spaces
//           if (regex.test(e.target.value)) {
//             handleInputChange(e); // Call your existing input handler only if valid
//           }
//         }}
//         sx={{
//           bgcolor: 'white',
//           borderRadius: 1,
//           '& .MuiOutlinedInput-root': {
//             '& fieldset': { borderColor: 'gray' },
//           },
//           '& .MuiInputBase-input': { color: 'black' },
//         }}
//         required
//         error={!formData.fullName}
//       />
//     </Grid>

//     <Grid item xs={12} sm={6} md={3}>
//       <TextField
//         fullWidth
//         placeholder="Email"
//         name="email"
//         value={formData.email}
//         onChange={(e) => {
//           const { name, value } = e.target;
//           setFormData((prevState) => ({
//             ...prevState,
//             [name]: value,
//           }));

//           // Inline email validation
//           if (name === 'email') {
//             const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//             e.target.setCustomValidity(emailRegex.test(value) ? '' : 'Invalid email address');
//           }
//         }}
//         sx={{
//           bgcolor: 'white',
//           borderRadius: 1,
//           '& .MuiOutlinedInput-root': {
//             '& fieldset': { borderColor: 'gray' },
//           },
//           '& .MuiInputBase-input': { color: 'black' },
//         }}
//         required
//         error={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && formData.email.length > 0}
//         helperText={
//           !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && formData.email.length > 0
//             ? 'Please enter a valid email address'
//             : ''
//         }
//       />
//     </Grid>

//     <Grid item xs={12} sm={6} md={3}>
//       <TextField
//         fullWidth
//         placeholder="Phone No."
//         name="phone"
//         value={formData.phone}
//         onChange={(e) => {
//           const regex = /^[0-9]*$/; // Allow only numeric input
//           if (regex.test(e.target.value) && e.target.value.length <= 10) {
//             handleInputChange(e); // Update the value only if it's valid
//           }
//         }}
//         sx={{
//           bgcolor: 'white',
//           borderRadius: 1,
//           '& .MuiOutlinedInput-root': {
//             '& fieldset': { borderColor: 'gray' },
//           },
//           '& .MuiInputBase-input': { color: 'black' },
//         }}
//         required
//         error={formData.phone.length !== 10}
//       />
//     </Grid>

//     <Grid item xs={12} sm={6} md="auto">
//       <Button
//         variant="contained"
//         onClick={() => {
//           // Check if any required field is empty
//           if (!formData.fullName || !formData.email || !formData.phone) {
//             Swal.fire({
//               title: 'Error!',
//               text: 'Please fill in all required fields.',
//               icon: 'error',
//               confirmButtonText: 'OK',
//               confirmButtonColor: '#d32f2f',
//             });
//             return;
//           }

//           // Check if email is valid
//           if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//             Swal.fire({
//               title: 'Error!',
//               text: 'Please enter a valid email address.',
//               icon: 'error',
//               confirmButtonText: 'OK',
//               confirmButtonColor: '#d32f2f',
//             });
//             return;
//           }

//           // Check if phone number is valid (10 digits)
//           if (formData.phone.length !== 10) {
//             Swal.fire({
//               title: 'Error!',
//               text: 'Please enter a valid 10-digit phone number.',
//               icon: 'error',
//               confirmButtonText: 'OK',
//               confirmButtonColor: '#d32f2f',
//             });
//             return;
//           }

//           handleFormSubmit();
//         }}
//         sx={{
//           bgcolor: '#7E22CE',
//           width: '200px', // Ensure consistent width
//           height: '55px', // Ensure consistent height
//           fontSize: '16px', // Optional: maintain readability
//           '&:hover': { bgcolor: '#6B21A8' },
//         }}
//       >
//         Submit
//       </Button>
//     </Grid>
//   </Grid>
// </Box>


 

//         {/* Footer Bottom */}

//         <Box sx={{ mt: 4, textAlign: 'center' }}>

//           <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>

//             By submitting this form, I consent to the processing of personal data in accordance with the Privacy Policy.

//           </Typography>

//           <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', mt: 2 }}>

//             The DataTech Labs Inc. All rights reserved ©2025

//           </Typography>

//         </Box>

//       </Container>

//     </Box>

//   );

// };

// function LandingPage() {

//   const [open, setOpen] = useState(false);

//   const navigate = useNavigate();

 

//   const [expanded, setExpanded] = useState(null);

 

//   const handleChange = (panel) => (event, isExpanded) => {

//     setExpanded(isExpanded ? panel : null);

//   };

 

//   useEffect(() => {

//     if (expanded === null) {

//       setExpanded('panel1'); // Automatically open the first panel if none are expanded

//     }

//   }, [expanded]);

 

//   return (

//     <ThemeProvider theme={theme}>

//       <Box sx={{ minHeight: '100vh', bgcolor: 'black', position: 'relative', overflow: 'hidden' }}>

//         {[...Array(6)].map((_, index) => (

//   <Box

//     key={index}

//     sx={{

//       position: 'absolute',

//       top: `${15 * index + 5}%`,

//       [index % 2 === 0 ? 'left' : 'right']: 0,

//       transform: 'translateX(0)',

//       width: '150px',

//       zIndex: 0,

//     }}

//   >

//     <img

//       src={index % 2 === 0 ? c2 : c1}

//       alt={`Decorative ${index % 2 === 0 ? 'Left' : 'Right'} ${index + 1}`}

//       style={{

//         width: '100%',

//         height: 'auto',

//         opacity: 0.7,

//       }}

//     />

//   </Box>

// ))}

// <Box

//     sx={{

//       position: 'absolute',

//       top: '30%',

//       left: 0,

//       transform: 'translateX(-50%)',

//       width: '150px',

//       zIndex: 0,

//     }}

//   >

//     <img

//       src={c5}

//       alt="Decorative Left"

//       style={{

//         width: '100%',

//         height: 'auto',

//         opacity: 0.7,

//       }}

//     />

//   </Box>

 

//   <Box

//     sx={{

//       position: 'absolute',

//       top: '40%',

//       right: 0,

//       transform: 'translateX(50%)',

//       width: '150px',

//       zIndex: 0,

//     }}

//   >

//     <img

//       src={c6}

//       alt="Decorative Right"

//       style={{

//         width: '100%',

//         height: 'auto',

//         opacity: 0.7,

//       }}

//     />

//   </Box>

 

 

 

//   <AppBar

//   position="fixed"

//   sx={{

//     background: 'white',

//     backdropFilter: 'blur(8px)',

//     boxShadow: 1,

//     px: { xs: 1, sm: 2, md: 4 },

//     height: { xs: '70px', sm: '70px', md: '80px' },

//   }}

// > 

//   <Toolbar

//     sx={{

//       display: 'flex',

//       justifyContent: 'space-between',

//       alignItems: 'center',

//       flexWrap: 'wrap',

//       height: '100%',

//     }}

//   >

//     {/* Left Side - Elephant Tank Logo */}

//     <Box

//       sx={{

//         display: 'flex',

//         alignItems: 'center',

//       }}

//     >

//       <Box

//         component="img"

//         src={ElphantTankLogo}

//         alt="Elephant Tank Logo"

//         sx={{

//           height: 'auto',

//           maxHeight: { xs: '35px', sm: '40px', md: '60px' },

//           maxWidth: { sm: '80px', md: '120px' },

//         }}

//       />

//     </Box>

 

//     {/* Right Side - DataTech and J4E Logos with Partition */}

//     <Box

//       sx={{

//         display: 'flex',

//         alignItems: 'center',

//         gap: { xs: 1, sm: 2, md: 3 },

//       }}

//     >

//       <Box

//         component="img"

//         src={Tdtllogo}

//         alt="DataTech Logo"

//         sx={{

//           height: 'auto',

//           maxHeight: { xs: '35px', sm: '40px', md: '60px' },

//           maxWidth: { sm: '80px', md: '120px' },

//         }}

//       />

 

//       {/* Partition Line */}

//       <Box

//         sx={{

//           height: { xs: '30px', sm: '35px', md: '45px' }, // Shorter partition line

//           width: '1px',

//           backgroundColor: '#E0E0E0',

//         }}

//       ></Box>

 

//       <Box

//         component="img"

//         src={J4E}

//         alt="J4E Logo"

//         sx={{

//           height: 'auto',

//           maxHeight: { xs: '35px', sm: '40px', md: '60px' },

//           maxWidth: { sm: '80px', md: '120px' },

//         }}

//       />

//     </Box>

//   </Toolbar>

// </AppBar>

 

 

 

 

 

//         {[...Array(6)].map((_, index) => (

//           <FloatingCube

//             key={index}

//             src={TDTLLogo}

//             alt=""

//             index={index}

//           />

//         ))}

 

       

// <Container

//   sx={{

//     pt: 5,

//     pb: 2,

//     position: 'relative',

//     background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)',

//     borderRadius: '16px',

//     boxShadow: '0 10px 40px rgba(39, 9, 67, 0.6)',

//   }}

// > 

// <Container

//   sx={{

//     pt: 8,

//     pb: 2,

//     mb:8,

//     position: 'relative',

//     // overflow: 'hidden', // Ensure images don't overflow the container

//     // background: '#010314',

//   }}

// > 

//   {/* Decorative Images on the Left */}

//   <Box

//     sx={{

//       position: 'absolute',

//       top: '10%',

//       left: '-10%',

//       width: '200px',

//       zIndex: 0, // Behind the text

//     }}

//   >

//     <img

//       src={p6} // Replace with your first image path

//       alt="Decorative Left Image 1"

//       style={{

//         width: '150%',

//         height: 'auto',

//         opacity: 1, // Adjust opacity if needed

//       }}

//     />

//   </Box>

//   <Box

//     sx={{

//       position: 'absolute',

//       bottom: '-50%',

//       left: '-20%',

//       width: '200px',

//       zIndex: 0, // Behind the text

//     }}

//   >

//     <img

//       src={c3} // Replace with your second image path

//       alt="Decorative Left Image 2"

//       style={{

//         width: '80%',

//         height: 'auto',

//         opacity: 0.8, // Adjust opacity if needed

//       }}

//     />

//   </Box>

 

//   {/* Decorative Images on the Right */}

//   <Box

//     sx={{

//       position: 'absolute',

//       top: '10%',

//       right: '-10%',

//       width: '200px',

//       zIndex: 0, // Behind the text

//     }}

//   >

//     <img

//       src={p7} // Replace with your third image path

//       alt="Decorative Right Image 1"

//       style={{

//         width: '150%',

//         height: 'auto',

//         opacity: 1, // Adjust opacity if needed

//       }}

//     />

//   </Box>

//   <Box

//     sx={{

//       position: 'absolute',

//       bottom: '-50%',

//       right: '-20%',

//       width: '200px',

//       zIndex: 0, // Behind the text

//     }}

//   >

//     <img

//       src={c4} // Replace with your fourth image path

//       alt="Decorative Right Image 2"

//       style={{

//         width: '80%',

//         height: 'auto',

//         opacity: 0.8, // Adjust opacity if needed

//       }}

//     />

//   </Box>

 

//   {/* Text Content */}

//   {/* <Box sx={{ textAlign: 'center', maxWidth: '800px', mx: 'auto', zIndex: 1 }}>

//     <Typography

//       variant="caption"

//       sx={{

//         display: 'inline-block',

//         px: 2,

//         py: 0.5,

//         bgcolor: 'rgba(10, 1, 19, 0.1)',

//         borderRadius: '100px',

//         color: '#d8b4fe',

//         mb: 3,

//         fontSize: '1.5rem',

//       }}

//     >

//       WELCOME TO ELEPHANT TANK & INNOVATEX

//     </Typography>

//     <Typography

//       variant="h2"

//       component="h1"

//       sx={{

//         color: 'white',

//         fontWeight: 'bold',

//         mb: 3,

//         fontSize: '2.5rem',

//         textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',

//       }}

//     >

//       <Typed

//         strings={[

//           'D.Y. Patil PGDM Institute Akurdi, Pune  Presents an Opportunity to Turn Your Ideas Into Impact with Elephant Tank and InnovateX.',

//         ]}

//         typeSpeed={50}

//         backSpeed={30}

//         loop={false}

//         showCursor={false}

//       />

//     </Typography>

//     <Typography

//       variant="h6"

//       sx={{

//         color: '#e9d5ff',

//         mb: 4,

//         textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',

//       }}

//     >

//       <Typed

//         strings={[

//           'A unique Platform combining funding, mentorship, and internship to make your vision into reality.',

//         ]}

//         typeSpeed={40}

//         backSpeed={20}

//         loop={false}

//         startDelay={3000}

//         showCursor={false}

//       />

//     </Typography>

//     <Box

//       sx={{

//         display: 'flex',

//         flexDirection: { xs: 'column', sm: 'row' },

//         gap: 2,

//         justifyContent: 'center',

//       }}

//     >

//       <div>

     

//       <Button

//         variant="outlined"

//         size="large"

//         onClick={() => setOpen(true)}

//         sx={{

//           background: '#010314',

//           borderRadius: '100px',

//           borderColor: '#9333EA',

//           color: '#d8b4fe',

//           '&:hover': {

//             borderColor: '#7E22CE',

//             bgcolor: 'rgba(147, 51, 234, 0.1)',

//           },

//           px: 4,

//           py: 1.5,

//         }}

//       >

//         Register for Elephant Tank

//       </Button>

 

    

//       <Dialog

//   open={open}

//   onClose={() => setOpen(false)}

//   sx={{

//     '& .MuiBackdrop-root': {

//       backgroundColor: 'rgba(5, 6, 14, 0.8)',

//     },

//     '& .MuiPaper-root': {

//       borderRadius: '16px',

//       padding: '16px',

//     },

//   }}

// > 

 

//   <Button

//     onClick={() => setOpen(false)}

//     sx={{

//       position: 'absolute',

//       top: 8,

//       right: 8,

//       minWidth: 'auto',

//       color: '#9333EA',

//       backgroundColor: 'purple',

//       '&:hover': {

//         backgroundColor: 'rgba(147, 51, 234, 0.1)',

//       },

//     }}

//   >

//     ✖

//   </Button>

 

//   <DialogTitle

//     sx={{

//       textAlign: 'center',

//       fontWeight: 'bold',

//       color: '#9333EA',

//     }}

//   >

//     Select Your Role

//   </DialogTitle>

//   <DialogContent

//     sx={{

//       display: 'flex',

//       justifyContent: 'center',

//       gap: 2,

//       px: 5,

//       py: 3,

//     }}

//   >

   

    

    

//     <Button

//       variant="contained"

//       size="large"

//       onClick={() => navigate('/StudentRegister')}

//       sx={{

//         background: '#9333EA',

//         color: 'white',

//         borderRadius: '50px',

//         px: 4,

//         py: 1.5,

//         '&:hover': {

//           bgcolor: '#7E22CE',

//         },

//       }}

//     >

//       Candidate

//     </Button>

 

//     <Button

//       variant="contained"

//       size="large"

//       onClick={() => navigate('/invesRegis')}

//       sx={{

//         background: '#9333EA',

//         color: 'white',

//         borderRadius: '50px',

//         px: 4,

//         py: 1.5,

//         '&:hover': {

//           bgcolor: '#7E22CE',

//         },

//       }}

//     >

//       Investor

//     </Button>

 

//   </DialogContent>

// </Dialog>

 

 

//     </div>

//       <Button

//         component="a"

//         href="https://innovatex.elephant-tank.com/"

//         target="_blank"

//         rel="noopener noreferrer"

//         variant="outlined"

//         size="large"

//         sx={{

//           background: '#010314',

//           borderRadius: '100px',

//           borderColor: '#9333EA',

//           color: '#d8b4fe',

//           '&:hover': {

//             borderColor: '#7E22CE',

//             bgcolor: 'rgba(147, 51, 234, 0.1)',

//           },

//           px: 4,

//           py: 1.5,

//         }}

//       >

//         Apply For InnovateX

//       </Button>

//     </Box>

//   </Box> */}

 

// <Box sx={{ textAlign: 'center', maxWidth: '800px', mx: 'auto', zIndex: 1 }}>

//   {/* Logo Section with Continuous Animation */}

//   <Box sx={{ mb: 1 }}>

   

//       <Box

//         component="img"

//         src={DYPLogo} // Replace with your actual logo path

//         alt="Logo"

//         sx={{

//           height: 'auto',

//           maxHeight: { xs: '80px', sm: '100px', md: '120px' }, // Adjust logo size for different screen sizes

//         }}

//       />

//   </Box>

 

 

//   {/* <Typography

//     variant="caption"

//     sx={{

//       display: 'inline-block',

//       px: 2,

//       py: 0.5,

//       bgcolor: 'rgba(10, 1, 19, 0.1)',

//       borderRadius: '100px',

//       color: '#d8b4fe',

//       mb: 3,

//       fontSize: '1.5rem',

//     }}

//   >

//     WELCOME TO ELEPHANT TANK & INNOVATEX

//   </Typography> */}

 

 

 

//   {/* <Typography

//     variant="h2"

//     component="h1"

//     sx={{

//       color: 'white',

//       fontWeight: 'bold',

//       mb: 3,

//       fontSize: '2.5rem',

//       textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',

//     }}

//   >

//     <Typed

//       strings={[

//         'D.Y. Patil PGDM Institute Akurdi, Pune (DYPPGDMI) presents an opportunity to turn your ideas into reality @ Elephant Tank and InnovateX events on 31st January, 2025 and 1st February 2025 at our elite Campus. ',

//       ]}

//       typeSpeed={50}

//       backSpeed={30}

//       loop={false}

//       showCursor={false}

//     />

//   </Typography>

//   <Typography

//     variant="h6"

//     sx={{

//       color: '#e9d5ff',

//       mb: 4,

//       textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',

//     }}

//   >

//     <Typed

//       strings={[

//         'Join the Revolution and Make Your Ideas Count!',

//       ]}

//       typeSpeed={40}

//       backSpeed={20}

//       loop={false}

//       startDelay={3000}

//       showCursor={false}

//     />

//   </Typography> */}

// <Swiper
//       spaceBetween={30}
//       slidesPerView={1}
//       loop={true}
//       pagination={{ clickable: true }}
//       modules={[Pagination, Autoplay]}
//       autoplay={{
//         delay: 2000, // Delay between slides in milliseconds
//         disableOnInteraction: false,
//       }}
//       style={{
//         width: '100%',
//         height: '100%',
//         // backgroundColor: '#000', // Background for the entire swiper
//         padding: '20px',
//       }}
//     >
//       {/* First Slide */}
//       <SwiperSlide
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           textAlign: 'center',
//           color: '#fff',
//           height: '100%',
//         }}
//       >
//         <Typography
//           variant="h2"
//           component="h1"
//           style={{
//             color: 'white',
//             fontWeight: 'bold',
//             marginBottom: '20px',
//             fontSize: '2.5rem',
//             textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',
//           }}
//         >
//           D.Y. Patil PGDM Institute Akurdi, Pune (DYPPGDMI) presents an opportunity to turn your ideas into reality @ Elephant Tank and InnovateX events on 31st January, 2025 and 1st February 2025 at our elite Campus.

//         </Typography>
//         <Typography
//           variant="h6"
//           style={{
//             color: '#e9d5ff',
//             marginBottom: '30px',
//             textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',
//           }}
//         >
//           Join the Revolution and Make Your Ideas Count!
//         </Typography>
//       </SwiperSlide>

//       {/* Second Slide */}
//       <SwiperSlide
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           textAlign: 'center',
//           color: '#fff',
//           height: '100%',
//         }}
//       >
//         <Typography
//           variant="h4"
//           component="h2"
//           style={{
//             color: 'white',
//             fontWeight: 'bold',
//             marginBottom: '20px',
//             textShadow: '0 0 15px rgba(255, 165, 0, 0.8)',
//           }}
//         >
//           Elephant Tank
//         </Typography>
//         <Typography
//           variant="h2"
//           component="h1"
//           style={{
//             color: 'white',
//             fontWeight: 'bold',
//             marginBottom: '20px',
//             fontSize: '2.5rem',
//             textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',
//           }}
//         >
//           Step Into the Spotlight with Elephant Tank Your Big Ideas Deserve Big Breaks!
//         </Typography>
//         <Typography
//           variant="h6"
//           style={{
//             color: '#e9d5ff',
//             marginBottom: '20px',
//             textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',
//           }}
//         >
//           Bring your dreams to life with funding, expert mentorship, and much more. Whether it’s a ground-breaking Business idea or an Innovative solution, Elephant Tank is your Launchpad to success!
//         </Typography>
//       </SwiperSlide>

//       {/* Third Slide */}
//       <SwiperSlide
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           textAlign: 'center',
//           color: '#fff',
//           height: '100%',
//         }}
//       >
//         <Typography
//           variant="h4"
//           component="h2"
//           style={{
//             color: 'white',
//             fontWeight: 'bold',
//             marginBottom: '20px',
//             textShadow: '0 0 15px rgba(173, 216, 230, 0.8)',
//           }}
//         >
//           InnovateX
//         </Typography>
//         <Typography
//           variant="h2"
//           component="h1"
//           style={{
//             color: 'white',
//             fontWeight: 'bold',
//             marginBottom: '20px',
//             fontSize: '2.5rem',
//             textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',
//           }}
//         >
//           Unleash Your Potential with InnovateX Where Creativity Meets Opportunity!
//         </Typography>
//         <Typography
//           variant="h6"
//           style={{
//             color: '#e9d5ff',
//             marginBottom: '30px',
//             textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',
//           }}
//         >
//           Dive into a one-of-a-kind platform to turn your vision into impact. With mentorship, internships, and resources at your fingertips, InnovateX is your gateway to making a difference and a niche in the industry.
//         </Typography>
//       </SwiperSlide>
//     </Swiper>

 

//   <Box

//     sx={{

//       display: 'flex',

//       flexDirection: { xs: 'column', sm: 'row' },

//       gap: 2,

//       justifyContent: 'center',

//     }}

//   >

//     <div>

//       {/* Main Button */}

//       <Button

//         variant="outlined"

//         size="large"

//         onClick={() => setOpen(true)} // Inline handler to open the dialog

//         sx={{

//           background: '#010314',

//           borderRadius: '100px',

//           borderColor: '#9333EA',

//           color: '#d8b4fe',

//           '&:hover': {

//             borderColor: '#7E22CE',

//             bgcolor: 'rgba(147, 51, 234, 0.1)',

//           },

//           px: 4,

//           py: 1.5,

//         }}

//       >

//         Register @ Elephant Tank

//       </Button>

 

//       {/* Dialog */}

//       <Dialog

//         open={open}

//         onClose={() => setOpen(false)}

//         sx={{

//           '& .MuiBackdrop-root': {

//             backgroundColor: 'rgba(5, 6, 14, 0.8)', // Solid backdrop color with slight opacity

//           },

//           '& .MuiPaper-root': {

//             borderRadius: '16px',

//             padding: '16px',

//           },

//         }}

//       >

//         {/* Close Button on Top-Right */}

//         <Button

//           onClick={() => setOpen(false)}

//           sx={{

//             position: 'absolute',

//             top: 8,

//             right: 8,

//             minWidth: 'auto',

//             color: '#9333EA',

//             backgroundColor: 'purple',

//             '&:hover': {

//               backgroundColor: 'rgba(147, 51, 234, 0.1)',

//             },

//           }}

//         >

//           ✖

//         </Button>

 

//         <DialogTitle

//           sx={{

//             textAlign: 'center',

//             fontWeight: 'bold',

//             color: '#9333EA',

//           }}

//         >

//           Select Your Role

//         </DialogTitle>

//         <DialogContent

//           sx={{

//             display: 'flex',

//             justifyContent: 'center', // Align buttons horizontally

//             gap: 2, // Add spacing between buttons

//             px: 5,

//             py: 3,

//           }}

//         >

//           {/* Investor Button */}

 

//           {/* Candidate Button */}

//           <Button

//             variant="contained"

//             size="large"

//             onClick={() => navigate('/StudentRegister')} // Navigate to Candidate route

//             sx={{

//               background: '#9333EA',

//               color: 'white',

//               borderRadius: '50px',

//               px: 4,

//               py: 1.5,

//               '&:hover': {

//                 bgcolor: '#7E22CE',

//               },

//             }}

//           >

//             Candidate

//           </Button>

 

//           <Button

//             variant="contained"

//             size="large"

//             onClick={() => navigate('/invesRegis')} // Navigate to Investor route

//             sx={{

//               background: '#9333EA',

//               color: 'white',

//               borderRadius: '50px',

//               px: 4,

//               py: 1.5,

//               '&:hover': {

//                 bgcolor: '#7E22CE',

//               },

//             }}

//           >

//             Investor

//           </Button>

//         </DialogContent>

//       </Dialog>

//     </div>

//     <Button

//       component="a"

//       onClick={() => navigate('/jobformp3')}

//             target="_blank"

//       rel="noopener noreferrer"

//       variant="outlined"

//       size="large"

//       sx={{

//         background: '#010314',

//         borderRadius: '100px',

//         borderColor: '#9333EA',

//         color: '#d8b4fe',

//         '&:hover': {

//           borderColor: '#7E22CE',

//           bgcolor: 'rgba(147, 51, 234, 0.1)',

//         },

//         px: 4,

//         py: 1.5,

//       }}

//     >

//       Apply for internship @ InnovateX

//     </Button>

//   </Box>

// </Box>

 

 

// </Container>

 

// </Container>

 

 

 

//         {/* About Section */}

//         <Container

//       sx={{

//         py: 5,

//         background: '#010314',

//         color: 'white',

//         mb:3,

//         zIndex:10,

//       }}

//     >

      

 

   

//       {/* Title */}

//       <Typography

//         variant="h2"

//         sx={{

//           textAlign: 'center',

//           mb: 4,

//           fontSize: { xs: '2.5rem', md: '3.5rem' },

//           fontWeight: 'bold',

//           position: 'relative',

//           '&::after': {

//             content: '""',

//             position: 'absolute',

//             bottom: -16,

//             left: '50%',

//             transform: 'translateX(-50%)',

//             width: 100,

//             height: 4,

//             background: 'linear-gradient(90deg, transparent, #361C82, transparent)',

//             borderRadius: 2,

//           },

//         }}

//       >

//         About the Event

//       </Typography>

 

//       <Grid container spacing={6}>

//         {/* Elephant Tank Section */}

//        <Grid item xs={12} md={6}>

//       <Box

//         sx={{

//           background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, rgba(102, 51, 238, 0.37) 69.34%, rgba(255, 255, 255, 0.37) 100%)',

//           borderRadius: '16px',

//           padding: '32px',

//           boxShadow: '0px 10px 20px rgba(39, 9, 67, 0.6)',

//           transition: 'transform 0.3s ease, box-shadow 0.3s ease',

//           '&:hover': {

//             transform: 'scale(1.02)',

//             boxShadow: '0px 15px 40px rgba(39, 9, 67, 0.8)',

//           },

//         }}

//       >

//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>

//           <Box

//             sx={{

//               width: 56,

//               height: 56,

//               background: 'rgba(39, 9, 67, 0.58)',

//               borderRadius: '16px',

//               display: 'flex',

//               alignItems: 'center',

//               justifyContent: 'center',

//               fontSize: '2rem',

//             }}

//           >

//             🐘

//           </Box>

//           <Typography

//             variant="h4"

//             sx={{

//               fontWeight: 'bold',

//               color: '#ffffff',

//             }}

//           >

//             Elephant Tank

//           </Typography>

//         </Box>

 

//         <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>

//           <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1-header">

//             <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

//               What is Elephant Tank?

//             </Typography>

//           </AccordionSummary>

//           <AccordionDetails>

//             <Typography sx={{ color: '#e9d5ff', lineHeight: 1.8 }}>

//               Elephant Tank is more than just an idea-pitching competition—it’s a launchpad for aspiring Entrepreneurs and Innovators. Unlike the traditional “Shark Tank,” this platform embodies the strength, wisdom, and nurturing spirit of the elephant, offering participants opportunities to grow and thrive through:

//               <br />• Seed Funding: Access investments from industry leaders to transform your ideas into reality.

//             </Typography>

//           </AccordionDetails>

//         </Accordion>

 

//         <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>

//           <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel2-header">

//             <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

//               Important Dates & Details

//             </Typography>

//           </AccordionSummary>

//           <AccordionDetails>

//             <Typography sx={{ color: '#e9d5ff' }}>

//               • <b>Last Date of Registration:</b> 15th January, 2024 <br />

//               • <b>Last Date of Idea Submission:</b> 20th January, 2025 <br />

//               • <b>Dates for Idea Presentation:</b> 31st January, 2025 / 1st February, 2025 <br />

//               • <b>Venue:</b> D Y Patil PGDM Institute, Dr. D.Y. Patil Educational Complex, Sector 29, Akurdi, Pune 411044 <br />

//               • <b>Group Strength:</b> Minimum 01 to Maximum 05 students <br />

//               • <b>Time:</b> 9:00 AM to 5:00 PM (Both Days) <br />

//               • <b>Note:</b> No Registration Fees

//             </Typography>

//           </AccordionDetails>

//         </Accordion>

 

//         <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>

//           <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel3-header">

//             <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

//               Eligibility Criteria

//             </Typography>

//           </AccordionSummary>

//           <AccordionDetails>

//             <Typography sx={{ color: '#e9d5ff' }}>

//               • <b>Undergraduate Students:</b> Students from diverse fields such as BBA, B.Com, B.Sc., B.Tech/B.E., B.Arch, B.Pharm, BFA, and other streams (First to final year students). <br />

//               • <b>Postgraduate Students:</b> Participants pursuing MBA, MCA, PGDM, M.Pharm, M.Tech, M.Sc., M.Arch, and other postgraduate programs.

//             </Typography>

//           </AccordionDetails>

//         </Accordion>

 

//         <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>

//           <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel4-header">

//             <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

//               Prizes & Awards

//             </Typography>

//           </AccordionSummary>

//           <AccordionDetails>

//             <Typography sx={{ color: '#e9d5ff' }}>

//               • <b>Cash Awards:</b> Rs. 25,000 (1st), Rs. 15,000 (2nd), Rs. 10,000 (3rd) <br />

//               • <b>Recognition:</b> Winners will be awarded certificates and trophies. <br />

//               • <b>Funding Opportunities:</b> Angel investors will support winning ideas. <br />

//               • <b>Additional Funding:</b> Exceptional ideas beyond the top three may receive funding.

//             </Typography>

//           </AccordionDetails>

//         </Accordion>

//       </Box>

//     </Grid>

 

//         {/* Elephant Tank Image */}

//         <Grid item xs={12} md={6}>

//         <Box

//   component="video"

//   src={v1} // Replace `v1` with the path to your video file

//   alt="Elephant Tank Video"

//   muted

//   loop

//   autoPlay

 

//   sx={{

//     width: '100%',

//     height: 'auto',

//     borderRadius: 4,

//     mt:15,

//     boxShadow: '4px 4px 50px 15px #361C82',

//     objectFit: 'cover',

//   }}

// />

 

//         </Grid>

 

//         {/* InnovateX Image */}

//         <Grid item xs={12} md={6}>

//         <Box

//   component="video"

//   src={v2} // Replace `v2` with the path to your video file

//   alt="InnovateX Video"

//   muted

//   loop

//   autoPlay

//   sx={{

//     width: '100%',

//     height: 'auto',

//     borderRadius: 4,

//     mt:10,

//     boxShadow: '4px 4px 50px 15px #361C82',

//     objectFit: 'cover',

//   }}

// />

 

//         </Grid>

 

//         {/* InnovateX Section */}

//         <Grid item xs={12} md={6}>

//   <Box

//     sx={{

//       background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, rgba(102, 51, 234, 0.37) 69.34%, rgba(255, 255, 255, 0.37) 100%)',

//       borderRadius: '16px',

//       padding: '32px',

//       boxShadow: '0px 10px 20px rgba(39, 9, 67, 0.6)',

//       transition: 'transform 0.3s ease, box-shadow 0.3s ease',

//       '&:hover': {

//         transform: 'scale(1.02)',

//         boxShadow: '0px 15px 40px rgba(39, 9, 67, 0.8)',

//       },

//     }}

//   >

//     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>

//       <Box

//         sx={{

//           width: 56,

//           height: 56,

//           background: 'rgba(39, 9, 67, 0.58)',

//           borderRadius: '16px',

//           display: 'flex',

//           alignItems: 'center',

//           justifyContent: 'center',

//           fontSize: '2rem',

//         }}

//       >

//         🚀

//       </Box>

//       <Typography

//         variant="h4"

//         sx={{

//           fontWeight: 'bold',

//           color: '#ffffff',

//         }}

//       >

//         InnovateX

//       </Typography>

//     </Box>

 

//     <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>

//       <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1-header">

//         <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

//           What is InnovateX?

//         </Typography>

//       </AccordionSummary>

//       <AccordionDetails>

//         <Typography sx={{ color: '#e9d5ff', lineHeight: 1.8 }}>

//         InnovateX is a unique research and POC internship initiative bridging academics with industry. It offers:      

//            <br />• Mentorship: Expert guidance to refine your vision.

//           <br />• Internships: Real-world exposure and career-building opportunities.

//           <br />• Collaboration: Work with top companies on real challenges.

//           <br />• Hands-On Experience: Develop practical research and POC skills.

//           <br />• Certification: Earn globally recognized credentials to boost your profile.

//         </Typography>

//       </AccordionDetails>

//     </Accordion>

 

//     <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>

//       <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel2-header">

//         <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

//           Eligibility Criteria

//         </Typography>

//       </AccordionSummary>

//       <AccordionDetails>

//         <Typography sx={{ color: '#e9d5ff', lineHeight: 1.8 }}>

//           • <b>Undergraduate Students:</b> Open to students from disciplines like BBA, B.Com, B.Sc., B.Tech/B.E., B.Arch, B.Pharm, BFA, and others. Students from the first year to the final year are welcome to test the industry waters.

//           <br />• <b>Postgraduate Students:</b> Open to those pursuing programs such as MBA, MCA, PGDM, M.Pharm, M.Tech, M.Sc., M.Arch, and others.

//         </Typography>

//       </AccordionDetails>

//     </Accordion>

 

//     <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>

//       <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel3-header">

//         <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

//           Important Dates & Details

//         </Typography>

//       </AccordionSummary>

//       <AccordionDetails>

//         <Typography sx={{ color: '#e9d5ff' }}>

//           • <b>Last Date of Registration:</b> 20th January, 2024 <br />

//           • <b>Dates for Interview with Industry on Campus:</b> 31st January, 2025 / 1st February, 2025 <br />

//           • <b>Venue:</b> D Y Patil PGDM Institute, Dr. D.Y. Patil Educational Complex, Sector 29, Akurdi, Pune 411044 <br />

//           • <b>Time:</b> 9:00 AM to 5:00 PM (Both Days) <br />

//           • <b>Note:</b> No Registration Fees

//         </Typography>

//       </AccordionDetails>

//     </Accordion>

 

//     <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>

//       <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel4-header">

//         <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

//           Outcomes for InnovateX

//         </Typography>

//       </AccordionSummary>

//       <AccordionDetails>

//         <Typography sx={{ color: '#e9d5ff', lineHeight: 1.8 }}>

//           • <b>Premium Internships:</b> Access to exclusive internships with leading organizations. <br />

//           • <b>Skill Development:</b> Enhance practical skills and industry readiness for a competitive edge. <br />

//           • <b>Networking Opportunities:</b> Build valuable connections for future career growth. <br />

//           • <b>Certification of Excellence:</b> Receive official certificates recognizing contributions and learning.

//         </Typography>

//       </AccordionDetails>

//     </Accordion>

//   </Box>

// </Grid>

 

 

//       </Grid>

//     </Container>

 

 

 

//                 {/* Register Now Section */}

              

// <Box

//   sx={{

//     position: "relative",

//     py: 8,

//     px: 4,

//     background:

//       "radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)",

//     overflow: "hidden",

//     borderRadius: "24px",

//     boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",

//     mx: "auto",

//     maxWidth: "1200px",

//     mt: 6,

//   }}

// > 

//   <Container maxWidth="lg">

//     {/* <Typography

//       variant="h2"

//       sx={{

//         fontSize: { xs: "2rem", md: "3rem" },

//         fontWeight: 600,

//         color: "white",

//         textAlign: "center",

//         mb: 5,

//         textShadow: "0 0 15px rgba(52, 7, 95, 0.5)",

//       }}

//     >

//       Event Agenda

//     </Typography> */}

// <Typography

//               variant="h2"

//               sx={{

//                 color: 'white',

//                 textAlign: 'center',

//                 mb: 4,
                
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },

//                 fontWeight: 'bold',

//                 position: 'relative',

//                 '&::after': {

//                   content: '""',

//                   position: 'absolute',

//                   bottom: -16,

//                   left: '50%',

//                   transform: 'translateX(-50%)',

//                   width: 100,

//                   height: 4,

//                   background: 'linear-gradient(180deg, #000000 0%, #270583 100%)',

//                   borderRadius: 2,

//                 },

//               }}

//             >

//               Event Agenda for Elephant Tank

//             </Typography>

//             <Grid container spacing={4}>

//               {/* Day 1 */}

//               <Grid item xs={12} md={6}>

//                 <Accordion

//                   sx={{

//                     background: "rgba(147, 51, 234, 0.15)",

//                     borderRadius: "16px",

//                     boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",

//                   }}

//                 >

//                   <AccordionSummary

//                     expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}

//                     sx={{

//                       background: "#6633EE",

//                       borderRadius: "12px",

//                       color: "white",

//                       "& .MuiAccordionSummary-content": { alignItems: "center" },

//                     }}

//                   >

//                     <Typography

//                       variant="h5"

//                       sx={{

//                         fontWeight: "bold",

//                         textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

//                       }}

//                     >

//                       Day 1: January 31st, 2025

//                     </Typography>

//                   </AccordionSummary>

//                   <AccordionDetails

//                     sx={{

//                       color: "#e9d5ff",

//                       fontSize: "1rem",

//                       px: 2,

//                       py: 1,

//                     }}

//                   >

//                     {[

//                       { time: "9:00 AM - 10:00 AM", event: "Onsite Registration & Approval" },

//                       { time: "10:00 AM - 11:00 AM", event: "Inauguration & Welcome Address " },

//                       { time: "11:00 AM - 11:30 AM", event: "Networking Break" },

//                       {

//                         time: "11:30 AM - 12:30 PM",

//                         event: "Panel 1 - Bridging the Gap Between Management and Technology",

//                       },

//                       {

//                         time: "12:35 PM - 1:15 PM",

//                         event: "Session 1 - Digital Transformation in Business",

//                       },

//                       { time: "1:15 PM - 2:00 PM", event: "Lunch Break" },

//                       {

//                         time: "2:15 PM - 3:00 PM",

//                         event: "Panel 2 - Entrepreneurship in the Digital Age",

//                       },

//                       { time: "3:00 PM - 3:40 PM", event: "Session 2 - The Power of Networking" },

//                       { time: "3:45 PM onwards", event: "Onboards Internship & Interviews" },

//                     ].map((item, index) => (

//                       <Box

//                         key={index}

//                         sx={{

//                           display: "flex",

//                           alignItems: "center",

//                           mb: 1.5,

//                           borderBottom: "1px solid rgba(255, 255, 255, 0.1)",

//                           pb: 1,

//                           ":last-of-type": { borderBottom: "none" },

//                         }}

//                       >

//                         <Typography

//                           variant="body1"

//                           sx={{

//                             flex: "0 0 35%",

//                             fontWeight: 600,

//                             color: "#D8B4FE",

//                           }}

//                         >

//                           {item.time}

//                         </Typography>

//                         <Typography

//                           variant="body2"

//                           sx={{

//                             flex: "1 1 auto",

//                             color: "white",

//                           }}

//                         >

//                           {item.event}

//                         </Typography>

//                       </Box>

//                     ))}

//                   </AccordionDetails>



//                 </Accordion>

//               </Grid>

//               {/* Day 2 */}

//               <Grid item xs={12} md={6}>

//                 <Accordion

//                   sx={{

//                     background: "rgba(147, 51, 234, 0.15)",

//                     borderRadius: "16px",

//                     boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",

//                   }}

//                 >

//                   <AccordionSummary

//                     expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}

//                     sx={{

//                       background: "#6633EE",

//                       borderRadius: "12px",

//                       color: "white",

//                       "& .MuiAccordionSummary-content": { alignItems: "center" },

//                     }}

//                   >

//                     <Typography

//                       variant="h5"

//                       sx={{

//                         fontWeight: "bold",

//                         textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

//                       }}

//                     >

//                       Day 2: February 1st, 2025

//                     </Typography>

//                   </AccordionSummary>

//                   <AccordionDetails

//                     sx={{

//                       color: "#e9d5ff",

//                       fontSize: "1rem",

//                       px: 2,

//                       py: 1,

//                     }}

//                   >

//                     {[

//                       { time: "9:30 AM - 10:30 AM", event: "Panel 3 - Leveraging Technology to Future-Ready Teams" },

//                       { time: "10:30 AM - 11:00 AM", event: "Session 3 - People Analytics" },

//                       { time: "11:00 AM - 11:30 AM", event: "Networking Break" },

//                       { time: "11:30 AM - 12:30 PM", event: "Panel 4 - Building a Personal Brand" },

//                       { time: "12:30 PM - 1:15 PM", event: "Session 4 - Preparing for Hybrid and Remote Jobs" },

//                       { time: "1:15 PM - 2:15 PM", event: "Networking Lunch" },

//                       { time: "2:15 PM - 3:00 PM", event: "Panel 5 - Workforce Cross-Skilling" },

//                       { time: "3:00 PM - 3:45 PM", event: "Session 5 - AI in HR" },

//                       { time: "3:45 PM onwards", event: "Internship Interviews and Selection" },

//                     ].map((item, index) => (

//                       <Box

//                         key={index}

//                         sx={{

//                           display: "flex",

//                           alignItems: "center",

//                           mb: 1.5,

//                           borderBottom: "1px solid rgba(255, 255, 255, 0.1)",

//                           pb: 1,

//                           ":last-of-type": { borderBottom: "none" },

//                         }}

//                       >

//                         <Typography

//                           variant="body1"

//                           sx={{

//                             flex: "0 0 35%",

//                             fontWeight: 600,

//                             color: "#D8B4FE",

//                           }}

//                         >

//                           {item.time}

//                         </Typography>

//                         <Typography

//                           variant="body2"

//                           sx={{

//                             flex: "1 1 auto",

//                             color: "white",

//                           }}

//                         >

//                           {item.event}

//                         </Typography>

//                       </Box>

//                     ))}

//                   </AccordionDetails>



//                 </Accordion>

//               </Grid>

//             </Grid>

//             <Typography

// variant="h2"

// sx={{

//   color: 'white',

//   textAlign: 'center',

//   mb: 4,
//   mt:5,
//   fontSize: { xs: '2.5rem', md: '3.5rem' },

//   fontWeight: 'bold',

//   position: 'relative',

//   '&::after': {

//     content: '""',

//     position: 'absolute',
//     bottom: -16,

//     left: '50%',

//     transform: 'translateX(-50%)',

//     width: 100,

//     height: 4,

//     background: 'linear-gradient(180deg, #000000 0%, #270583 100%)',

//     borderRadius: 2,

//   },

// }}

// >

// Event Agenda for InnovateX

// </Typography>

// <Grid container spacing={4}>

// {/* Day 1 */}

// <Grid item xs={12} md={6}>

//   <Accordion

//     sx={{

//       background: "rgba(147, 51, 234, 0.15)",

//       borderRadius: "16px",

//       boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",

//     }}

//   >

//     <AccordionSummary

//       expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}

//       sx={{

//         background: "#6633EE",

//         borderRadius: "12px",

//         color: "white",

//         "& .MuiAccordionSummary-content": { alignItems: "center" },

//       }}

//     >

//       <Typography

//         variant="h5"

//         sx={{

//           fontWeight: "bold",

//           textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

//         }}

//       >

//         Day 1: January 31st, 2025

//       </Typography>

//     </AccordionSummary>

//     <AccordionDetails

//       sx={{

//         color: "#e9d5ff",

//         fontSize: "1rem",

//         px: 2,

//         py: 1,

//       }}

//     >

//       {[

//         { time: "9:00 AM - 5:00 PM", event: "Internship Interviews for Immediate On boarding" },


//       ].map((item, index) => (

//         <Box

//           key={index}

//           sx={{

//             display: "flex",

//             alignItems: "center",

//             mb: 1.5,

//             borderBottom: "1px solid rgba(255, 255, 255, 0.1)",

//             pb: 1,

//             ":last-of-type": { borderBottom: "none" },

//           }}

//         >

//           <Typography

//             variant="body1"

//             sx={{

//               flex: "0 0 35%",

//               fontWeight: 600,

//               color: "#D8B4FE",

//             }}

//           >

//             {item.time}

//           </Typography>

//           <Typography

//             variant="body2"

//             sx={{

//               flex: "1 1 auto",

//               color: "white",

//             }}

//           >

//             {item.event}

//           </Typography>

//         </Box>

//       ))}

//     </AccordionDetails>



//   </Accordion>

// </Grid>

// {/* Day 2 */}

// <Grid item xs={12} md={6}>

//   <Accordion

//     sx={{

//       background: "rgba(147, 51, 234, 0.15)",

//       borderRadius: "16px",

//       boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",

//     }}

//   >

//     <AccordionSummary

//       expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}

//       sx={{

//         background: "#6633EE",

//         borderRadius: "12px",

//         color: "white",

//         "& .MuiAccordionSummary-content": { alignItems: "center" },

//       }}

//     >

//       <Typography

//         variant="h5"

//         sx={{

//           fontWeight: "bold",

//           textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

//         }}

//       >

//         Day 2: February 1st, 2025

//       </Typography>

//     </AccordionSummary>

//     <AccordionDetails

//       sx={{

//         color: "#e9d5ff",

//         fontSize: "1rem",

//         px: 2,

//         py: 1,

//       }}

//     >

//       {[

//         { time: "9:00 AM - 5:00 PM", event: "Internship Interviews for Immediate On boarding" },

//         { time: "9:00 AM - 5:00 PM", event: "Valedictory Function & Declaration of Winners and Internship Awardees" },

        

//       ].map((item, index) => (

//         <Box

//           key={index}

//           sx={{

//             display: "flex",

//             alignItems: "center",

//             mb: 1.5,

//             borderBottom: "1px solid rgba(255, 255, 255, 0.1)",

//             pb: 1,

//             ":last-of-type": { borderBottom: "none" },

//           }}

//         >

//           <Typography

//             variant="body1"

//             sx={{

//               flex: "0 0 35%",

//               fontWeight: 600,

//               color: "#D8B4FE",

//             }}

//           >

//             {item.time}

//           </Typography>

//           <Typography

//             variant="body2"

//             sx={{

//               flex: "1 1 auto",

//               color: "white",

//             }}

//           >

//             {item.event}

//           </Typography>

//         </Box>

//       ))}

//     </AccordionDetails>



//   </Accordion>

// </Grid>

// </Grid>

//   </Container>

// </Box>

 

// <Box

//       sx={{

//         backgroundColor: "#0f172a",

//         borderRadius: "20px",

//         padding: "50px",

//         maxWidth: "1200px",

//         margin: "50px auto",

//         border: "1px solid rgba(255, 255, 255, 0.2)",

//         boxShadow: "0 0 50px rgba(80, 80, 255, 0.4)",

//         position: "relative",

//       }}

//     >

//       {/* Title */}

//       <Typography

//         variant="h2"

//         sx={{

//           fontSize: { xs: "2rem", md: "3rem" },

//           fontWeight: 600,

//           color: "white",

//           textAlign: "center",

//           mb: 5,

//           textShadow: "0 0 15px rgba(52, 7, 95, 0.5)",

//         }}

//       >

//         Objectives 

//       </Typography>

 

//       {/* Objectives of Elephant Tank */}

//       <Box

//         sx={{

//           display: "flex",

//           flexDirection: { xs: "column", md: "row" },

//           gap: "30px",

//           alignItems: "flex-start",

//           mb: 4,

//         }}

//       >

//         <Box

//           sx={{

//             flex: 1,

//             background: "linear-gradient(145deg, #4527A0, #6A1B9A)",

//             padding: "30px",

//             borderRadius: "16px",

//             boxShadow: "0 10px 25px rgba(80, 80, 255, 0.2)",

//           }}

//         >

//           <Typography

//             variant="h5"

//             sx={{

//               color: "#FFFFFF",

//               fontWeight: "bold",

//               textTransform: "uppercase",

//               mb: 2,

//               textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

//             }}

//           >

//             Objectives of Elephant Tank

//           </Typography>

//           <Typography

//             variant="body1"

//             sx={{

//               color: "#E0E0E0",

//               fontSize: "1.1rem",

//               lineHeight: 1.8,

//             }}

//           >

//             <ul

//               style={{

//                 margin: 0,

//                 paddingLeft: "20px",

//                 listStyleType: "disc",

//                 color: "#E0E0E0",

//               }}

//             >

//               <li>Empowering Innovation: To provide a platform for aspiring entrepreneurs to present and refine their innovative ideas, fostering creativity and practical problem-solving.</li>

//               <li>Facilitating Growth: To connect participants with industry leaders, offering seed funding and mentorship to transform ideas into viable ventures.</li>

//               <li>Building Entrepreneurial Ecosystems: To nurture a community of forward-thinking individuals and promote cross-disciplinary collaboration among students and professionals.</li>

//             </ul>

//           </Typography>

//         </Box>

 

//         {/* Objectives of InnovateX */}

//         <Box

//           sx={{

//             flex: 1,

//             background: "linear-gradient(145deg, #4527A0, #6A1B9A)",

//             padding: "30px",

//             borderRadius: "16px",

//             boxShadow: "0 10px 25px rgba(80, 80, 255, 0.2)",

//           }}

//         >

//           <Typography

//             variant="h5"

//             sx={{

//               color: "#FFFFFF",

//               fontWeight: "bold",

//               textTransform: "uppercase",

//               mb: 2,

//               textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

//             }}

//           >

//             Objectives of InnovateX

//           </Typography>

//           <Typography

//             variant="body1"

//             sx={{

//               color: "#E0E0E0",

//               fontSize: "1.1rem",

//               lineHeight: 1.8,

//             }}

//           >

//             <ul

//               style={{

//                 margin: 0,

//                 paddingLeft: "20px",

//                 listStyleType: "disc",

//                 color: "#E0E0E0",

//               }}

//             >

//               <li>Real-World Learning: To bridge the gap between academics and industry by offering students hands-on experiences through internships and projects.</li>

//               <li>Skill Enhancement: To equip participants with practical skills and industry-relevant knowledge, preparing them for dynamic career opportunities.</li>

//               <li>Career Development: To provide a Launchpad for students to network with professionals, explore career pathways, and build a robust foundation for future success.</li>

//             </ul>

//           </Typography>

//         </Box>

//       </Box>

//     </Box>

 

 

 

// {/* agenda */}

// <Box

//   sx={{

//     position: "relative",

//     py: 10,

//     background:

//       "radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)",

//     overflow: "hidden",

//     borderRadius: "24px",

//     boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",

//     mx: "auto",

//     maxWidth: "1200px",

//   }}

// > 

 

//   <Container maxWidth="md">

//     <Box sx={{ position: "relative" }}>

//       <Box sx={{ textAlign: "center", position: "relative", zIndex: 2 }}>

//         {/* Title */}

//         <Typography

//           variant="h1"

//           sx={{

//             fontSize: { xs: "2.5rem", md: "4.5rem" },

//             fontWeight: 500,

//             color: "white",

//             mb: 2,

//             textShadow: "0 0 20px rgba(52, 7, 95, 0.5)",

//           }}

//         >

//           Register Now!!!

//         </Typography>

 

//         {/* Dynamic Date */}

//         <Typography

//           variant="h4"

//           sx={{

//             color: "#e9d5ff",

//             mb: 3,

//             fontWeight: "medium",

//           }}

//         >

//           {getCurrentDate()} upto January 28, 2025 | India

//         </Typography>

 

//         {/* Description */}

//         <Typography

//           variant="h5"

//           sx={{

//             color: "#e9d5ff",

//             mb: 3,

//             maxWidth: "800px",

//             mx: "auto",

//             opacity: 0.8,

//           }}

//         >

//           <Typed

//             strings={[

//               "Ready to make an impact? Don't miss this opportunity to showcase your talent and bring your ideas to life!",

//             ]}

//             typeSpeed={40}

//             backSpeed={20}

//             showCursor={false} // Disable cursor after animation

//             loop={false} // Run the animation only once

//             onComplete={() => {

//               console.log("Typing animation completed");

//             }}

//           />

//         </Typography>

 

//         {/* Buttons */}

//         <Box

//           sx={{

//             display: "flex",

//             gap: 3,

//             justifyContent: "center",

//             flexWrap: "wrap",

//           }}

//         >

//           <div>

//       {/* Main Button */}

//       <Button

//         variant="outlined"

//         size="large"

//         onClick={() => setOpen(true)} // Inline handler to open the dialog

//         sx={{

//           background: '#010314',

//           borderRadius: '100px',

//           borderColor: '#9333EA',

//           color: '#d8b4fe',

//           '&:hover': {

//             borderColor: '#7E22CE',

//             bgcolor: 'rgba(147, 51, 234, 0.1)',

//           },

//           px: 4,

//           py: 1.5,

//         }}

//       >

//         Register @ Elephant Tank

//       </Button>

 

//       {/* Dialog */}

//       <Dialog
//   open={open}
//   onClose={() => setOpen(false)}
//   fullWidth
//   maxWidth="sm" // Restrict max width for smaller screens
//   sx={{
//     '& .MuiBackdrop-root': {
//       backgroundColor: 'rgba(5, 6, 14, 0.8)', // Solid backdrop color with slight opacity
//     },
//     '& .MuiPaper-root': {
//       borderRadius: '16px',
//       padding: '16px',
//       backgroundColor: 'white', // Set popup background color to white
//     },
//   }}
// >
//   {/* Close Button on Top-Right */}
//   <Button
//     onClick={() => setOpen(false)}
//     sx={{
//       position: 'absolute',
//       top: 8,
//       right: 8,
//       minWidth: 'auto',
//       color: '#9333EA',

    
//     }}
//   >
//     ✖
//   </Button>

//   <DialogTitle
//     sx={{
//       textAlign: 'center',
//       fontWeight: 'bold',
//       color: '#9333EA',
//     }}
//   >
//     Select Your Role
//   </DialogTitle>
//   <DialogContent
//     sx={{
//       display: 'flex',
//       flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens, row on larger
//       justifyContent: 'center', // Align buttons
//       alignItems: 'center', // Center items vertically
//       gap: 2, // Add spacing between buttons
//       px: { xs: 2, sm: 5 }, // Responsive padding
//       py: 3,
//     }}
//   >
//     {/* Entrepreneur Button */}
//     <Button
//       variant="contained"
//       size="large"
//       onClick={() => navigate('/StudentRegister')} // Navigate to Entrepreneur route
//       sx={{
//         background: '#9333EA',
//         color: 'white',
//         borderRadius: '50px',
//         px: 4,
//         py: 1.5,
//         width: { xs: '100%', sm: 'auto' }, // Full width on small screens
//         '&:hover': {
//           bgcolor: '#7E22CE',
//         },
//       }}
//     >
//       Students & Buding Entrepreneurs
//     </Button>

//     {/* Investor Button */}
//     <Button
//       variant="contained"
//       size="large"
//       onClick={() => navigate('/invesRegis')} // Navigate to Investor route
//       sx={{
//         background: '#9333EA',
//         color: 'white',
//         borderRadius: '50px',
//         px: 4,
//         py: 1.5,
//         width: { xs: '100%', sm: 'auto' }, // Full width on small screens
//         '&:hover': {
//           bgcolor: '#7E22CE',
//         },
//       }}
//     >
//       Angel Investors & Mentors
//     </Button>
//   </DialogContent>
// </Dialog>

 

 

 

//     </div>

 

//     <Button

//         component="a"

//         onClick={() => navigate('/jobformp3')}

//         target="_blank"

//         rel="noopener noreferrer"

//         variant="outlined"

//         size="large"

//         sx={{

//           background: '#010314',

//           borderRadius: '100px',

//           borderColor: '#9333EA',

//           color: '#d8b4fe',

//           '&:hover': {

//             borderColor: '#7E22CE',

//             bgcolor: 'rgba(147, 51, 234, 0.1)',

//           },

//           px: 4,

//           py: 1.5,

//         }}

//       >

//         Apply For Internship @ InnovateX

//       </Button>

//         </Box>

//       </Box>

 

//       {/* Robot Mascot */}

//       <Box

//         component="img"

//         src={robo} // Replace with the actual image path

//         alt="Robot Mascot"

//         sx={{

//           position: "absolute",

//           right: { xs: "-100px", md: "-50px" },

//           bottom: { xs: "-100px", md: "-50px" },

//           width: { xs: "200px", md: "300px" },

//           opacity: 0.9,

//           transform: "rotate(10deg)",

//           filter: "drop-shadow(0 0 20px rgba(147, 51, 234, 0.3))",

//         }}

//       />

//     </Box>

//   </Container>

// </Box>

// {/* impact */}

// <Box

//       sx={{

//         backgroundColor: "#0f172a",

//         borderRadius: "20px",

//         padding: "50px",

//         maxWidth: "1200px",

//         margin: "50px auto",

//         border: "1px solid rgba(255, 255, 255, 0.2)",

//         boxShadow: "0 0 50px rgba(80, 80, 255, 0.4)",

//         position: "relative",

//       }}

//     >

//       {/* Title */}

//       {/* <Typography

//         variant="h4"

//         align="center"

//         sx={{

//           color: "#ffffff",

//           fontWeight: "bold",

//           textTransform: "uppercase",

//           letterSpacing: "0.2em",

//           mb: 4,

//           textShadow: "0px 0px 15px rgba(255, 255, 255, 0.8)",

//         }}

//       >

//         Impact and Expected Outcomes

//       </Typography> */}

//       <Typography

//     variant="h2"

//     sx={{

//       color: 'white',

//       textAlign: 'center',

//       mb: 4,

//       fontSize: { xs: '2.5rem', md: '3.5rem' },

//       fontWeight: 'bold',

//       position: 'relative',

//       '&::after': {

//         content: '""',

//         position: 'absolute',

//         bottom: -16,

//         left: '50%',

//         transform: 'translateX(-50%)',

//         width: 100,

//         height: 4,

//         background: 'linear-gradient(180deg, #000000 0%, #270583 100%)',

//         borderRadius: 2,

//       },

//     }}

//   >

//     Impact and Expected Outcomes

//   </Typography>

 

//       {/* Content Section */}

//       <Box

//         sx={{

//           background: "linear-gradient(145deg, #4527A0, #6A1B9A)",

//           padding: "30px",

//           borderRadius: "16px",

//           boxShadow: "0 10px 25px rgba(80, 80, 255, 0.2)",

//         }}

//       >

//         <Typography

//           variant="body1"

//           sx={{

//             color: "#E0E0E0",

//             fontSize: "1.1rem",

//             lineHeight: 1.8,

//             display: "flex",

//             flexDirection: "column",

//             gap: "15px",

//           }}

//         >

//           <span>

//             <strong>1. </strong>

//             Startups gain access to fresh talent capable of contributing to

//             research, development, and Proof of Concept projects.

//           </span>

//           <span>

//             <strong>2. </strong>

//             Students receive internship offers, mentorship, and the opportunity

//             to work in a dynamic startup environment.

//           </span>

//           <span>

//             <strong>3. </strong>

//             Strengthening the collaboration between academia and the startup

//             ecosystem, providing a platform for continuous internship

//             opportunities.

//           </span>

//           <span>

//             <strong>4. </strong>

//             Creating a platform at the college for internship drives and future

//             startup engagement initiatives, ensuring a sustainable system for

//             talent and knowledge exchange.

//           </span>

//         </Typography>

//       </Box>

//     </Box>

// {/* //why particpiate */}

// <Container

//   sx={{

//     py: 5,

//     position: 'relative',

//     color: '#fff',

//     background: 'radial-gradient(circle at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)',

//     borderRadius: '20px',

//     boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',

//     overflow: 'hidden',

//     mt: 5,

//   }}

// > 

//   <Typography

//     variant="h2"

//     sx={{

//       color: 'white',

//       textAlign: 'center',

//       mb: 4,

//       fontSize: { xs: '2.5rem', md: '3.5rem' },

//       fontWeight: 'bold',

//       position: 'relative',

//       '&::after': {

//         content: '""',

//         position: 'absolute',

//         bottom: -16,

//         left: '50%',

//         transform: 'translateX(-50%)',

//         width: 100,

//         height: 4,

//         background: 'linear-gradient(180deg, #000000 0%, #270583 100%)',

//         borderRadius: 2,

//       },

//     }}

//   >

//     Why Participate?

//   </Typography>

 

//   <Grid container spacing={5}>

//     {[

//       {

//         icon: <LightbulbIcon sx={{ fontSize: 40 }} />,

//         title: 'Transform Ideas into Reality',

//         description: 'Pitch your innovative solutions and make a difference.',

//       },

//       {

//         icon: <MenuBookIcon sx={{ fontSize: 40 }} />,

//         title: 'Learn from the Best',

//         description: 'Collaborate with industry leaders and mentors.',

//       },

//       {

//         icon: <PublicIcon sx={{ fontSize: 40 }} />,

//         title: 'Experience Real-World Innovation',

//         description: 'Work on impactful projects through InnovateX',

//       },

//       {

//         icon: <RocketLaunchIcon sx={{ fontSize: 40 }} />,

//         title: 'Boost Your Career',

//         description: 'Add funding, mentorship, and certifications to your portfolio.',

//       },

//     ].map((item, index) => (

//       <Grid item xs={12} sm={6} md={3} key={index}>

//         <Box

//           sx={{

//             borderRadius: '40px 0 40px 0', // Two sharp corners (top-right, bottom-left) and two more curved corners (top-left, bottom-right)

//             background: 'linear-gradient(180deg, #000000 0%, #270583 100%)', // Gradient background

//             height: '80%',

//             display: 'flex',

//             flexDirection: 'column',

//             alignItems: 'center',

//             textAlign: 'center',

//             p: 4,

//             color: '#fff',

//             boxShadow: '4px 4px 60px 0px #8C8C8C', // Enhanced shadow for cards

//           }}

//         >

//           <Box

//             sx={{

//               width: 80,

//               height: 80,

//               bgcolor: 'rgba(147, 51, 234, 0.2)',

//               borderRadius: '50px', // Fully circular

//               display: 'flex',

//               alignItems: 'center',

//               justifyContent: 'center',

//               mb: 3,

//               color: '#e9d5ff',

//             }}

//           >

//             {item.icon}

//           </Box>

//           <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>

//             {item.title}

//           </Typography>

//           <Typography sx={{ color: '#e9d5ff' }}>{item.description}</Typography>

//         </Box>

//       </Grid>

//     ))}

//   </Grid>

// </Container>

 

//         {/* Demo Video Section */}

//         <Container sx={{ py: 10, position: 'relative' }}>

//       <Box

//         sx={{

//           position: 'relative',

//           width: '100%',

//           maxWidth: '900px',

//           mx: 'auto',

//           borderRadius: 4,

//           overflow: 'hidden',

//           boxShadow: '10px 10px 10px 10px rgba(128, 0, 128, 0.5)', // Purple shadow

//           '&::before': {

//             content: '""',

//             display: 'block',

//             paddingTop: '56.25%', // 16:9 Aspect Ratio

//           },

//         }}

//       >

//         <Box

//           component="video"

//           src={sampleVideo} // Use the imported video file as the source

//           controls

//           sx={{

//             position: 'absolute',

//             top: 0,

//             left: 0,

//             width: '100%',

//             height: '100%',

//             borderRadius: 4,

//             bgcolor: 'rgba(147, 51, 234, 0.1)',

//           }}

//         />

//       </Box>

//     </Container>

 

//         {/* How it works   */}

    

//         <Container

//   sx={{

//     py: 3,

//     position: 'relative',

//     background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)',

//     color: 'white',

//     borderRadius: 4,

//     overflow: 'hidden',

//   }}

// > 

//   {/* Section Title */}

//   <Typography

//     variant="h2"

//     sx={{

//       textAlign: 'center',

//       mb: 4,

//       fontSize: { xs: '2.5rem', md: '3.5rem' },

//       fontWeight: 'bold',

//       position: 'relative',

//       zIndex: 2,

//       '&::after': {

//         content: '""',

//         position: 'absolute',

//         bottom: -16,

//         left: '50%',

//         transform: 'translateX(-50%)',

//         width: 100,

//         height: 4,

//         background: 'linear-gradient(90deg, transparent, #9333EA, transparent)',

//         borderRadius: 2,

//       },

//     }}

//   >

//     How Elephant Tank Works?

//   </Typography>

 

//   {/* Main Content */}

//   <Grid container spacing={4} alignItems="center">

//     {/* Left Side: Full Image */}

//     <Grid item xs={12} md={5}>

//       <Box

//         sx={{

//           width: '100%',

//           height: '100%',

//           maxHeight: 500,

//           display: 'flex',

//           justifyContent: 'center',

//           alignItems: 'center',

//           overflow: 'hidden',

//         }}

//       >

//         <img

//           src={p5} // Replace with the actual image path

//           alt="How it Works Illustration"

//           style={{

//             width: '100%',

//             height: 'auto',

//             objectFit: 'contain',

//             borderRadius: 8,

//           }}

//         />

//       </Box>

//     </Grid>

 

//     {/* Right Side: 2x2 Structure of Cards */}

//     <Grid item xs={12} md={7}>

//       <Grid container spacing={3}>

//         {[

//           {

//             image: p1,

//             title: 'Register Your Idea',

//             description: 'Share your innovative idea or project proposal with us through our registration portal.',

//           },

//           {

//             image: p2,

//             title: 'Get Shortlisted',

//             description: 'A panel of experts will evaluate submissions based on creativity, feasibility, and scalability.',

//           },

//           {

//             image: p3,

//             title: 'Pitch Your Idea',

//             description: 'Present your solution to a panel of investors during Elephant Tank.',

//           },

//           {

//             image: p4,

//             title: 'Get Funded',

//             description: 'Elephant Tank is your gateway to securing funding for your ideas.',

//           },

//         ].map((step, index) => (

//           <Grid item xs={12} sm={6} key={index}>

//             <Box

//               sx={{

//                 display: 'flex',

//                 flexDirection: 'column',

//                 bgcolor: 'white',

//                 borderRadius: 4,

//                 overflow: 'hidden',

//                 boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',

//                 height: '100%',

//               }}

//             >

//               {/* Top Half: Vector Image */}

//               <Box

//                 sx={{

//                   width: '100%',

//                   height: 150,

//                   bgcolor: '#F8F8FF',

//                   display: 'flex',

//                   justifyContent: 'center',

//                   alignItems: 'center',

//                 }}

//               >

//                 <img

//                   src={step.image} // Replace with the vector image path

//                   alt={step.title}

//                   style={{

//                     width: '80%',

//                     height: '100%',

//                     objectFit: 'contain',

//                   }}

//                 />

//               </Box>

 

//               {/* Bottom Half: Content */}

//               <Box sx={{ p: 3, textAlign: 'center', flex: 1 }}>

//                 <Typography

//                   variant="h6"

//                   sx={{ mb: 1, color: '#1a1a1a', fontWeight: 'bold' }}

//                 >

//                   {step.title}

//                 </Typography>

//                 <Typography

//                   variant="body2"

//                   sx={{ color: '#666666', lineHeight: 1.5 }}

//                 >

//                   {step.description}

//                 </Typography>

//               </Box>

//             </Box>

//           </Grid>

//         ))}

//       </Grid>

//     </Grid>

//   </Grid>

// </Container>

 

 

 

//         {/* FAQ Section */}

//         <FAQSection />

 

//         {/* Contact Section */}

//         <Box

//   sx={{

//     background: 'linear-gradient(135deg, #6B21A8 0%, #4C1D95 100%)',

//     borderRadius: '32px',

//     p: { xs: 4, md: 6 },

//     mx: 'auto',

//     my: 10,

//     maxWidth: '1200px',

//     width: '90%',

//     display: 'flex',

//     flexDirection: { xs: 'column', md: 'row' },

//     alignItems: 'flex-start', // Align items to the start

//     justifyContent: 'space-between',

//     gap: { xs: 4, md: 0 },

//     boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.3)',

//   }}

// > 

//   {/* Left Side */}

//   <Box sx={{ flex: 1 }}>

//     <Typography

//       variant="h2"

//       sx={{

//         color: 'white',

//         fontSize: { xs: '2.5rem', md: '3rem' },

//         fontWeight: 'bold',

//         mb: 2,

//         lineHeight: '1.2',

//         textAlign: 'left', // Align text to the left

//       }}

//     >

//       Contact Us

//     </Typography>

//     <Typography

//       sx={{

//         color: 'rgba(255, 255, 255, 0.9)',

//         fontSize: { xs: '1rem', md: '1.2rem' },

//         maxWidth: '500px',

//         textAlign: 'left', // Align text to the left

//       }}

//     >

//       Have questions? Reach out to us at Email Address :<strong> support@elephant-tank.com</strong> or call us at{' '}

//       <strong>9225584954 / 9225585835</strong>.

//     </Typography>

//   </Box>

 

//   {/* Right Side */}

//   <Box

//   sx={{

//     display: 'flex',

//     gap: 2,

//     width: { xs: '100%', md: 'auto' },

//     maxWidth: { xs: '100%', md: '500px' },

//     alignItems: 'center',

//   }}

// > 

//   <TextField

//     placeholder="Enter your email address..."

//     variant="outlined"

//     fullWidth

//     sx={{

//       '& .MuiOutlinedInput-root': {

//         background: 'rgba(0, 0, 0, 0.8)',

//         borderRadius: '50px',

//         border: '2px solid rgba(255, 255, 255, 0.3)',

//         '&:hover fieldset': {

//           borderColor: 'rgba(255, 255, 255, 0.5)',

//         },

//         '&.Mui-focused fieldset': {

//           borderColor: 'rgba(255, 255, 255, 0.8)',

//         },

//       },

//       '& .MuiOutlinedInput-input': {

//         py: 1.5,

//         px: 3,

//         color: 'white',

//       },

//     }}

//     InputProps={{

//       endAdornment: (

//         <Button

//           variant="contained"

//           onClick={() => {

//             const emailField = document.querySelector(

//               '[placeholder="Enter your email address..."]'

//             );

//             const email = emailField?.value.trim();

//             const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

 

//             if (emailRegex.test(email)) {

//               emailField.setCustomValidity('');

//               window.location.href = '/StudentRegister'; // Redirects to Student Register

//             } else {

//               emailField.setCustomValidity('Invalid email address.');

//               emailField.reportValidity();

//             }

//           }}

//           sx={{

//             background: 'linear-gradient(135deg, #9333EA, #7E22CE)',

//             color: 'white',

//             px: 4,

//             borderRadius: '50px',

//             fontWeight: 'bold',

//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',

//             whiteSpace: 'nowrap',

//             '&:hover': {

//               background: 'linear-gradient(135deg, #7E22CE, #6B21A8)',

//             },

//           }}

//         >

//           Sign Up

//         </Button>

//       ),

//     }}

//   />

// </Box>

 

// </Box>
//    <Footer />
// <GradientBox />
// </Box>

//     </ThemeProvider>

//   );

// }
// export default LandingPage;

import React, { useState, useEffect } from 'react';

import {

  AppBar,

  Toolbar,

  Button,

  TextField,

  Container,

  Typography,

  Grid,

  Card,

  CardContent,

  Select,

  Box,

  FormControl,

  MenuItem,

  InputLabel,

  styled,

  Table,

  TableBody,

  TableCell,

  List,

  ListItem,

  ListItemText,

  TableRow,

  Collapse

} from '@mui/material';
import Confetti from 'react-confetti';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TDTLLogo from "./landpageimage1/TDTLLogo.png"
import one from "./landpageimage1/aa.JPG"
import two from "./landpageimage1/bb.JPG"
import three from "./landpageimage1/cc.JPG"
import four from "./landpageimage1/a.JPG"

import LightbulbIcon from '@mui/icons-material/Lightbulb';

import { ReactTyped as Typed } from 'react-typed';

import { motion } from 'framer-motion';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

import MenuBookIcon from '@mui/icons-material/MenuBook';

import PublicIcon from '@mui/icons-material/Public';

import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

import AddIcon from '@mui/icons-material/Add';

import RemoveIcon from '@mui/icons-material/Remove';

import DYPLogo from './landpageimage/DYPLogo.png';

import ElphantTankLogo from './landpageimage/elephanttanklogo.png';

import Chatbotimage from './landpageimage1/Bot.png';

import Swal from 'sweetalert2';

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {  Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

import { Pagination, Autoplay} from 'swiper/modules';

 

 

import pana from './landpageimage1/pana.png';

import ElephantTank from './landpageimage1/ElephantTank.png';

import GetAttachmentThumbnail from './landpageimage1/GetAttachmentThumbnail.png';

import Tdtllogo from './landpageimage/TDTLLogo.png';

import { Link as ScrollLink } from 'react-scroll';

import { useNavigate } from 'react-router-dom';

import J4E from './landpageimage/logo2.jpg'

import { Link } from 'react-router-dom';

import v1 from './video/v1.mp4'

import v2 from './video/v2.mp4'

import v3 from './video/v3.mp4'

import v4 from './video/v4.mp4'

import sampleVideo from './video/invideo-ai-1080 Transform Your Ideas into Reality with E 2024-12-22.mp4'

import p1 from './landpageimage/discarded-idea/p1.svg'

import p2 from './landpageimage/pana.png'

import p3 from './landpageimage/rafiki.png'

import p4 from './landpageimage/cuate.png'

import p5 from './landpageimage/Group 1000001937.png'

import p6 from './landpageimage/CubeLeft.png'

import p7 from './landpageimage/CubeRight.png'

import c1 from './landpageimage/Clip path group-1.png'

import c2 from './landpageimage/Clip path group-2.png'

import c3 from './landpageimage/Ellipse 4.png'

import c4 from './landpageimage/Ellipse 6.png'

import c5 from './landpageimage/Circle.png'

import c6 from './landpageimage/Circle.png'

 

import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";


 

import {

  Facebook,

  LinkedIn,

  Twitter,

  Instagram,

  WhatsApp,

} from '@mui/icons-material';

import robo from './landpageimage/Bot.png'

import {  Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import EmailIcon from '@mui/icons-material/Email';

import PhoneIcon from '@mui/icons-material/Phone';

import LocationOnIcon from '@mui/icons-material/LocationOn';

import {

  LaptopMac as LaptopIcon,

  PresentToAll as PresentationIcon,

  CheckCircle as CheckCircleIcon,

  School as SchoolIcon

} from '@mui/icons-material';

 

const GradientBox = styled(Box)(({ theme }) => ({

  position: 'absolute',

  inset: 0,

  background: 'linear-gradient(180deg, rgba(88, 28, 135, 0.2) 0%, transparent 100%)',

  pointerEvents: 'none',

}));

function getCurrentDate() {

  const options = { year: "numeric", month: "long", day: "numeric" };

  return new Date().toLocaleDateString("en-US", options);

}

 

 

 

const StyledCard = styled(Card)(({ theme }) => ({

  background: 'rgba(88, 28, 135, 0.15)',

  backdropFilter: 'blur(20px)',

  border: '1px solid rgba(147, 51, 234, 0.2)',

  borderRadius: theme.shape.borderRadius * 2,

  color: '#fff',

  height: '100%',

  transition: 'all 0.3s ease',

  '&:hover': {

    transform: 'translateY(-5px)',

    boxShadow: '0 8px 30px rgba(147, 51, 234, 0.2)'

  }

}));

 

const FloatingCube = styled('img')(({ theme, index }) => ({

  position: 'absolute',

  width: '100px',

  height: '100px',

  opacity: 0.5,

  animation: `float ${2 + index * 0.5}s ease-in-out infinite alternate`,

  left: index % 2 === 0 ? '25%' : '75%',

  top: index < 2 ? '25%' : index < 4 ? '50%' : '75%',

  '@keyframes float': {

    '0%': {

      transform: 'translateY(0px) rotate(0deg)',

    },

    '100%': {

      transform: `translateY(${20 + index * 5}px) rotate(${5 + index * 2}deg)`,

    },

  },

}));

 

const StarIcon = styled('div')(({ theme }) => ({

  width: '40px',

  height: '40px',

  position: 'absolute',

  opacity: 0.6,

  '&::before, &::after': {

    content: '""',

    position: 'absolute',

    background: 'white',

    width: '2px',

    height: '20px',

    left: '50%',

    top: '50%',

    transform: 'translate(-50%, -50%)',

  },

  '&::after': {

    transform: 'translate(-50%, -50%) rotate(90deg)',

  },

  animation: 'twinkle 1.5s ease-in-out infinite',

  '@keyframes twinkle': {

    '0%, 100%': { opacity: 0.6 },

    '50%': { opacity: 1 },

  }

}));

 

const ProcessCard = styled(Card)(({ theme }) => ({

  background: 'rgba(255, 255, 255, 0.95)',

  borderRadius: '24px',

  overflow: 'hidden',

  height: '100%',

  transition: 'transform 0.3s ease-in-out',

  '&:hover': {

    transform: 'translateY(-8px)',

  },

}));

 

const FAQTable = styled(Box)(({ theme }) => ({

  background: 'rgba(255, 255, 255, 0.95)',

  borderRadius: '24px',

  overflow: 'hidden',

  '& .MuiTableCell-root': {

    borderColor: 'rgba(147, 51, 234, 0.1)',

  },

}));

 

const theme = createTheme({

  palette: {

    mode: 'dark',

    primary: {

      main: '#9333EA',

    },

    background: {

      default: '#0A0118',

      paper: 'rgba(88, 28, 135, 0.2)',

    },

  },

});

 

function FAQSection() {

  const [expandedRow, setExpandedRow] = useState(null);

 

  const handleRowClick = (index) => {

    setExpandedRow(expandedRow === index ? null : index);

  };

 

  const faqs = [

    {

      question: "Who Can Participate?",

      answer:

        "Any UG/PG Student with an innovative idea is welcome to join! Eligibility Criteria:\n• Undergraduate Students: Students from various disciplines such as BBA, B.Com, B.Sc., B.Tech/B.E., B.Arch, B.Pharm, BFA, and others (first to final year students are eligible to pitch their ideas).\n• Postgraduate Students: Participants enrolled in programs like MBA, MCA, PGDM, M.Pharm, M.Tech, M.Sc., M.Arch, and similar courses can also participate.",

    },

    {

      question: "What is the Registration Fee?",

      answer: "There is no registration fee for participating in the event.",

    },

    {

      question: "Can I Participate in Both Events?",

      answer:

        "Yes, absolutely! We encourage participants to maximize their opportunities by joining both programs. You can pitch your idea in Elephant Tank and further develop it through the InnovateX internship program. Special combined registration options are also available.",

    },


  ];

 

 

  return (

    <Container sx={{ py: 10 }}>

      {/* FAQ Title */}

      <Typography

        variant="h2"

        sx={{

          color: 'white',

          textAlign: 'center',

          mb: 4,

          fontSize: { xs: '2.5rem', md: '3.5rem' },

          fontWeight: 'bold',

          position: 'relative',

          '&::after': {

            content: '""',

            position: 'absolute',

            bottom: -16,

            left: '50%',

            transform: 'translateX(-50%)',

            width: 100,

            height: 4,

            background: 'linear-gradient(90deg, transparent, #9333EA, transparent)',

            borderRadius: 2,

          },

        }}

      >

        FAQ's

      </Typography>

 

      {/* FAQ Table */}

      <Table>

        <TableBody>

          {faqs.map((faq, index) => (

            <React.Fragment key={index}>

              {/* Question Row */}

              <TableRow

                onClick={() => handleRowClick(index)}

                sx={{

                  cursor: 'pointer',

                  '&:hover': {

                    bgcolor: 'rgba(147, 51, 234, 0.05)',

                  },

                }}

              >

                <TableCell

                  sx={{

                    p: 3,

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'space-between',

                  }}

                >

                  <Typography

                    variant="h6"

                    sx={{

                      color: 'white',

                      fontWeight: 'medium',

                    }}

                  >

                    {index + 1}. {faq.question}

                  </Typography>

                  <Box

                    sx={{

                      width: 32,

                      height: 32,

                      display: 'flex',

                      alignItems: 'center',

                      justifyContent: 'center',

                      borderRadius: '50%',

                      bgcolor: expandedRow === index ? '#9333EA' : 'rgba(147, 51, 234, 0.1)',

                      transition: 'all 0.3s ease',

                    }}

                  >

                    {expandedRow === index ? (

                      <RemoveIcon sx={{ color: expandedRow === index ? 'white' : '#9333EA' }} />

                    ) : (

                      <AddIcon sx={{ color: '#9333EA' }} />

                    )}

                  </Box>

                </TableCell>

              </TableRow>

 

              {/* Answer Row */}

              <TableRow>

                <TableCell sx={{ p: 0, border: 'none' }}>

                  <Collapse in={expandedRow === index}>

                    <Box

                      sx={{

                        p: 3,

                        pt: 0,

                        color: 'white',

                        bgcolor: 'rgba(255, 255, 255, 0.05)',

                      }}

                    >

                      <Typography>{faq.answer}</Typography>

                    </Box>

                  </Collapse>

                </TableCell>

              </TableRow>

            </React.Fragment>

          ))}

        </TableBody>

      </Table>

    </Container>

  );

}

const Footer = () => {

  // State to manage form inputs

  const [formData, setFormData] = useState({

    fullName: '',

    email: '',

    phone: '',

    message: '',

  });

 

  // Handle input changes

  const handleInputChange = (e) => {

    const { name, value } = e.target;

    setFormData((prevData) => ({

      ...prevData,

      [name]: value,

    }));

  };

 

  // Handle form submission

  const handleFormSubmit = () => {

    Swal.fire({

      title: 'Thank You!',

      text: 'Your enquiry has been submitted successfully.',

      icon: 'success',

      confirmButtonText: 'OK',

      confirmButtonColor: '#7E22CE',

    }).then(() => {

      setFormData({

        fullName: '',

        email: '',

        phone: '',

        message: '',

      });

    });

  };

 

  return (

    <Box sx={{ bgcolor: '#1A1A1A', color: 'white', pt: 4, pb: 4 }}>

      <Container maxWidth="lg">

      <Grid container spacing={3} justifyContent="space-between" alignItems="flex-start">

  {/* Industries Column */}

  {/* <Grid item xs={12} sm={6} md={3}>

    <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>

      INDUSTRIES

    </Typography>

    {['Banking & Financial Services', 'Energy & Commodities', 'Healthcare', 'Public Sector', 'Retail', 'Transportation & Mobility'].map((item) => (

      <Typography

        key={item}

        sx={{

          mb: 1.5,

          color: 'rgba(255,255,255,0.7)',

          display: 'flex',

          alignItems: 'center',

          gap: 1,

          cursor: 'pointer',

          '&:hover': { color: 'white' },

        }}

      >

        <Box component="span" sx={{ fontSize: '0.8rem' }}>▶</Box>

        {item}

      </Typography>

    ))}

  </Grid> */}

 

  {/* Services Column */}

  {/* <Grid item xs={12} sm={6} md={3}>

    <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>

      SERVICES

    </Typography>

    {['Business Transformation', 'Digital Transformation', 'Learning Transformation', 'Technology Training Programs'].map((item) => (

      <Typography

        key={item}

        sx={{

          mb: 1.5,

          color: 'rgba(255,255,255,0.7)',

          display: 'flex',

          alignItems: 'center',

          gap: 1,

          cursor: 'pointer',

          '&:hover': { color: 'white' },

        }}

      >

        <Box component="span" sx={{ fontSize: '0.8rem' }}>▶</Box>

        {item}

      </Typography>

    ))}

  </Grid> */}

 

  {/* Quick Links Column */}

  {/* <Grid item xs={12} sm={6} md={3}>

    <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>

      QUICK LINKS

    </Typography>

    {['Privacy Policy', 'Refund Policy', 'Terms & Conditions', 'Blogs'].map((item) => (

      <Typography

        key={item}

        sx={{

          mb: 1.5,

          color: 'rgba(255,255,255,0.7)',

          display: 'flex',

          alignItems: 'center',

          gap: 1,

          cursor: 'pointer',

          '&:hover': { color: 'white' },

        }}

      >

        <Box component="span" sx={{ fontSize: '0.8rem' }}>▶</Box>

        {item}

      </Typography>

    ))}

  </Grid> */}

 

  {/* Initiatives & Links */}

  {/* <Grid item xs={12} sm={6} md={3}>

    <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>

      INITIATIVES

    </Typography>

    {['Panther Diaries', 'Sutradhar HR'].map((item) => (

      <Typography

        key={item}

        sx={{

          mb: 1.5,

          color: 'rgba(255,255,255,0.7)',

          display: 'flex',

          alignItems: 'center',

          gap: 1,

          cursor: 'pointer',

          '&:hover': { color: 'white' },

        }}

      >

        <Box component="span" sx={{ fontSize: '0.8rem' }}>▶</Box>

        {item}

      </Typography>

    ))}

 

  

  </Grid> */}

</Grid>

 

 

        {/* Form Section */}

        <Box sx={{ mt: 8, textAlign: 'center' }}>

  <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>

    GET IN TOUCH, ENQUIRE NOW

  </Typography>

  <Grid container spacing={2} justifyContent="center">

    <Grid item xs={12} sm={6} md={3}>

    <TextField

  fullWidth

  placeholder="Full Name"

  name="fullName"

  type="text"

  value={formData.fullName}

  onChange={(e) => {

    const regex = /^[A-Za-z\s]*$/; // Regex to allow only letters and spaces

    if (regex.test(e.target.value)) {

      handleInputChange(e); // Call your existing input handler only if valid

    }

  }}

  sx={{

    bgcolor: 'white',

    borderRadius: 1,

    '& .MuiOutlinedInput-root': {

      '& fieldset': { borderColor: 'gray' },

    },

    '& .MuiInputBase-input': { color: 'black' },

  }}

  required

  error={!formData.fullName}

/>

 

    </Grid>

    <Grid item xs={12} sm={6} md={3}>

    <TextField
  fullWidth
  placeholder="Email"
  name="email"
  value={formData.email}
  onChange={(e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Inline email validation
    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      e.target.setCustomValidity(emailRegex.test(value) ? '' : 'Invalid email address');
    }
  }}
  sx={{
    bgcolor: 'white',
    borderRadius: 1,
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: 'gray' },
    },
    '& .MuiInputBase-input': { color: 'black' },
  }}
  required
  error={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && formData.email.length > 0}
  helperText={
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && formData.email.length > 0
      ? 'Please enter a valid email address'
      : ''
  }
/>


    </Grid>

    <Grid item xs={12} sm={6} md={3}>

    <TextField

  fullWidth

  placeholder="Phone No."

  name="phone"

  value={formData.phone}

  onChange={(e) => {

    const regex = /^[0-9]*$/; // Allow only numeric input

    if (regex.test(e.target.value) && e.target.value.length <= 10) {

      handleInputChange(e); // Update the value only if it's valid

    }

  }}

  sx={{

    bgcolor: 'white',

    borderRadius: 1,

    '& .MuiOutlinedInput-root': {

      '& fieldset': { borderColor: 'gray' },

    },

    '& .MuiInputBase-input': { color: 'black' },

  }}

  required

  error={formData.phone.length !== 10}

  

/>

 

    </Grid>

    <Grid item xs={12} sm={6} md="auto">
  <Button
    variant="contained"
    onClick={() => {
      if (!formData.fullName || !formData.email || !formData.phone) {
        Swal.fire({
          title: 'Error!',
          text: 'Please fill in all required fields.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d32f2f',
        });
        return;
      }

      handleFormSubmit();
    }}
    sx={{
      bgcolor: '#7E22CE',
      width: '200px', // Ensure consistent width
      height: '55px', // Ensure consistent height
      fontSize: '16px', // Optional: maintain readability
      '&:hover': { bgcolor: '#6B21A8' },
    }}
  >
    Submit
  </Button>
</Grid>


  </Grid>

</Box>

 

 

        {/* Footer Bottom */}

        <Box sx={{ mt: 4, textAlign: 'center' }}>

          <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>

            By submitting this form, I consent to the processing of personal data in accordance with the Privacy Policy.

          </Typography>

          <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', mt: 2 }}>

            The DataTech Labs Inc. All rights reserved ©2025

          </Typography>

        </Box>

      </Container>

    </Box>

  );

};

function LandingPage() {

  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

 

  const [expanded, setExpanded] = useState(null);

 

  const handleChange = (panel) => (event, isExpanded) => {

    setExpanded(isExpanded ? panel : null);

  };
  const particleOptions = {
    fullScreen: false,
    background: {
      color: "transparent",
    },
    particles: {
      number: {
        value: 80,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#ffffff",
      },
      shape: {
        type: "circle",
      },
      opacity: {
        value: 0.5,
      },
      size: {
        value: 3,
      },
      move: {
        enable: true,
        speed: 1.5,
      },
    },
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "repulse",
        },
      },
    },
  };
  const confettiStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
    // pointerEvents: 'none',
  };

  useEffect(() => {

    if (expanded === null) {

      setExpanded('panel1'); // Automatically open the first panel if none are expanded

    }

  }, [expanded]);

  const handleButtonClick = (eventCategory, eventLabel, customAction) => {
    // Log the event for GA
    if (window.gtag) {
      window.gtag('event', 'button_click', {
        event_category: eventCategory,
        event_label: eventLabel,
        value: 1,
      });
    }
  
    // Log the event for GTM
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'button_click',
        event_category: eventCategory,
        event_label: eventLabel,
        value: 1,
      });
    }
  
    // Execute any custom action (e.g., opening dialogs)
    if (typeof customAction === 'function') {
      customAction();
    }
  };


  return (

    <ThemeProvider theme={theme}>

      <Box sx={{ minHeight: '100vh', bgcolor: 'black', position: 'relative', overflow: 'hidden' }}>

        {[...Array(6)].map((_, index) => (

  <Box

    key={index}

    sx={{

      position: 'absolute',

      top: `${15 * index + 5}%`,

      [index % 2 === 0 ? 'left' : 'right']: 0,

      transform: 'translateX(0)',

      width: '150px',

      zIndex: 0,

    }}

  >

    <img

      src={index % 2 === 0 ? c2 : c1}

      alt={`Decorative ${index % 2 === 0 ? 'Left' : 'Right'} ${index + 1}`}

      style={{

        width: '100%',

        height: 'auto',

        opacity: 0.7,

      }}

    />

  </Box>

))}

<Box

    sx={{

      position: 'absolute',

      top: '30%',

      left: 0,

      transform: 'translateX(-50%)',

      width: '150px',

      zIndex: 0,

    }}

  >

    <img

      src={c5}

      alt="Decorative Left"

      style={{

        width: '100%',

        height: 'auto',

        opacity: 0.7,

      }}

    />

  </Box>

 

  <Box

    sx={{

      position: 'absolute',

      top: '40%',

      right: 0,

      transform: 'translateX(50%)',

      width: '150px',

      zIndex: 0,

    }}

  >

    <img

      src={c6}

      alt="Decorative Right"

      style={{

        width: '100%',

        height: 'auto',

        opacity: 0.7,

      }}

    />

  </Box>

 

 

 

  {/* <AppBar

  position="fixed"

  sx={{

    background: 'white',

    backdropFilter: 'blur(8px)',

    boxShadow: 1,

    px: { xs: 1, sm: 2, md: 4 },

    height: { xs: '70px', sm: '70px', md: '80px' },

  }}

> 

  <Toolbar

    sx={{

      display: 'flex',

      justifyContent: 'space-between',

      alignItems: 'center',

      flexWrap: 'wrap',

      height: '100%',

    }}

  >


    <Box

      sx={{

        display: 'flex',

        alignItems: 'center',

      }}

    >

      <Box

        component="img"

        src={ElphantTankLogo}

        alt="Elephant Tank Logo"

        sx={{

          height: 'auto',

          maxHeight: { xs: '35px', sm: '40px', md: '60px' },

          maxWidth: { sm: '80px', md: '120px' },

        }}

      />

    </Box>

 


    <Box

      sx={{

        display: 'flex',

        alignItems: 'center',

        gap: { xs: 1, sm: 2, md: 3 },

      }}

    >

      <Box

        component="img"

        src={Tdtllogo}

        alt="DataTech Logo"

        sx={{

          height: 'auto',

          maxHeight: { xs: '35px', sm: '40px', md: '60px' },

          maxWidth: { sm: '80px', md: '120px' },

        }}

      />

 


      <Box

        sx={{

          height: { xs: '30px', sm: '35px', md: '45px' }, 

          width: '1px',

          backgroundColor: '#E0E0E0',

        }}

      ></Box>

 

      <Box

        component="img"

        src={J4E}

        alt="J4E Logo"

        sx={{

          height: 'auto',

          maxHeight: { xs: '35px', sm: '40px', md: '60px' },

          maxWidth: { sm: '80px', md: '120px' },

        }}

      />

    </Box>

  </Toolbar>

</AppBar> */}

 

 
{/* <AppBar
  position="fixed"
  sx={{
    background: 'white',
    backdropFilter: 'blur(8px)',
    boxShadow: 1,
    px: { xs: 1, sm: 2, md: 4 },
    height: { xs: '60px', sm: '70px', md: '80px' }, // Adjust height for mobile
  }}
>
  <Toolbar
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      height: '100%',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box
        component="img"
        src={ElphantTankLogo}
        alt="Elephant Tank Logo"
        sx={{
          height: 'auto',
          maxHeight: { xs: '30px', sm: '40px', md: '60px' }, // Adjust logo height on mobile
          maxWidth: { xs: '70px', sm: '80px', md: '120px' }, // Adjust width for small screens
        }}
      />
    </Box>

    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1, sm: 2, md: 3 },
        justifyContent: { xs: 'flex-end', sm: 'flex-end', md: 'space-between' }, // Align logos to the right on small screens
        flexWrap: 'wrap', // Allow flex to wrap on small screens
      }}
    >
      <Box
        component="img"
        src={Tdtllogo}
        alt="DataTech Logo"
        sx={{
          height: 'auto',
          maxHeight: { xs: '30px', sm: '40px', md: '60px' },
          maxWidth: { xs: '60px', sm: '80px', md: '120px' }, // Adjust size for smaller screens
        }}
      />

      <Box
        sx={{
          height: { xs: '20px', sm: '30px', md: '45px' }, // Shorter partition line on mobile
          width: '1px',
          backgroundColor: '#E0E0E0',
          display: { xs: 'none', sm: 'block' }, // Hide partition on mobile
        }}
      ></Box>

      <Box
        component="img"
        src={J4E}
        alt="J4E Logo"
        sx={{
          height: 'auto',
          maxHeight: { xs: '30px', sm: '40px', md: '60px' },
          maxWidth: { xs: '60px', sm: '80px', md: '120px' }, // Adjust size for smaller screens
        }}
      />
    </Box>
  </Toolbar>
</AppBar> */}

 
<AppBar
  position="fixed"
  sx={{
    background: 'white',
    backdropFilter: 'blur(8px)',
    boxShadow: 1,
    px: { xs: 1, sm: 3, md: 4 }, // Adjust padding for responsiveness
    height: { xs: '60px', sm: '70px', md: '80px' }, // Dynamic height
  }}
>
  <Toolbar
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      height: '100%',
    }}
  >
    {/* Left Side - Elephant Tank Logo */}
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box
        component="img"
        src={ElphantTankLogo}
        alt="Elephant Tank Logo"
        sx={{
          height: 'auto',
          maxHeight: { xs: '40px', sm: '50px', md: '60px' }, // Adjust logo height for small screens
          maxWidth: { xs: '80px', sm: '100px', md: '120px' }, // Adjust width for mobile
        }}
      />
    </Box>

    {/* Right Side - DataTech and J4E Logos with Partition */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1, sm: 3, md: 4 }, // Adjust spacing between logos
        justifyContent: { xs: 'flex-end', sm: 'flex-end', md: 'space-between' }, // Align logos properly
        flexWrap: 'wrap', // Allow wrapping on smaller screens
      }}
    >
      <Box
        component="img"
        src={Tdtllogo}
        alt="DataTech Logo"
        sx={{
          height: 'auto',
          maxHeight: { xs: '35px', sm: '40px', md: '50px' }, // Make the logo size responsive
          maxWidth: { xs: '60px', sm: '100px', md: '120px' }, // Adjust width for small screens
        }}
      />

      {/* Partition Line */}
      <Box
        sx={{
          height: { xs: '25px', sm: '35px', md: '45px' }, // Short partition line for smaller screens
          width: '1px',
          backgroundColor: '#E0E0E0',
          display: { xs: 'none', sm: 'block' }, // Hide partition on mobile
        }}
      ></Box>

      <Box
        component="img"
        src={J4E}
        alt="J4E Logo"
        sx={{
          height: 'auto',
          maxHeight: { xs: '35px', sm: '40px', md: '50px' }, // Adjust logo size for small screens
          maxWidth: { xs: '80px', sm: '100px', md: '120px' }, // Adjust width for smaller screens
        }}
      />
    </Box>
  </Toolbar>
</AppBar>

 

 

        {[...Array(6)].map((_, index) => (

          <FloatingCube

            key={index}

            src={TDTLLogo}

            alt=""

            index={index}

          />

        ))}

 

       

<Container

  sx={{

    pt: 5,

    pb: 2,

    position: 'relative',

    background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)',

    borderRadius: '16px',

    boxShadow: '0 10px 40px rgba(39, 9, 67, 0.6)',

  }}

> 

<Container

  sx={{

    pt: 8,

    pb: 2,

    mb:8,

    position: 'relative',

    // overflow: 'hidden', // Ensure images don't overflow the container

    // background: '#010314',

  }}

> 

  {/* Decorative Images on the Left */}

  <Box

    sx={{

      position: 'absolute',

      top: '10%',

      left: '-10%',

      width: '200px',

      zIndex: 0, // Behind the text

    }}

  >

    <img

      src={p6} // Replace with your first image path

      alt="Decorative Left Image 1"

      style={{

        width: '110%',

        height: 'auto',

        opacity: 1, // Adjust opacity if needed

      }}

    />

  </Box>

  <Box

    sx={{

      position: 'absolute',

      bottom: '-50%',

      left: '-20%',

      width: '200px',

      zIndex: 0, // Behind the text

    }}

  >

    <img

      src={c3} // Replace with your second image path

      alt="Decorative Left Image 2"

      style={{

        width: '60%',

        height: 'auto',

        opacity: 0.8, // Adjust opacity if needed

      }}

    />

  </Box>

 

  {/* Decorative Images on the Right */}

  <Box

    sx={{

      position: 'absolute',

      top: '10%',

      right: '-10%',

      width: '200px',

      zIndex: 0, // Behind the text

    }}

  >

    <img

      src={p7} // Replace with your third image path

      alt="Decorative Right Image 1"

      style={{

        width: '150%',

        height: 'auto',

        opacity: 1, // Adjust opacity if needed

      }}

    />

  </Box>

  <Box

    sx={{

      position: 'absolute',

      bottom: '-50%',

      right: '-20%',

      width: '200px',

      zIndex: 0, // Behind the text

    }}

  >

    <img

      src={c4} // Replace with your fourth image path

      alt="Decorative Right Image 2"

      style={{

        width: '80%',

        height: 'auto',

        opacity: 0.8, // Adjust opacity if needed

      }}

    />

  </Box>

 

  {/* Text Content */}

  {/* <Box sx={{ textAlign: 'center', maxWidth: '800px', mx: 'auto', zIndex: 1 }}>

    <Typography

      variant="caption"

      sx={{

        display: 'inline-block',

        px: 2,

        py: 0.5,

        bgcolor: 'rgba(10, 1, 19, 0.1)',

        borderRadius: '100px',

        color: '#d8b4fe',

        mb: 3,

        fontSize: '1.5rem',

      }}

    >

      WELCOME TO ELEPHANT TANK & INNOVATEX

    </Typography>

    <Typography

      variant="h2"

      component="h1"

      sx={{

        color: 'white',

        fontWeight: 'bold',

        mb: 3,

        fontSize: '2.5rem',

        textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',

      }}

    >

      <Typed

        strings={[

          'D.Y. Patil PGDM Institute Akurdi, Pune  Presents an Opportunity to Turn Your Ideas Into Impact with Elephant Tank and InnovateX.',

        ]}

        typeSpeed={50}

        backSpeed={30}

        loop={false}

        showCursor={false}

      />

    </Typography>

    <Typography

      variant="h6"

      sx={{

        color: '#e9d5ff',

        mb: 4,

        textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',

      }}

    >

      <Typed

        strings={[

          'A unique Platform combining funding, mentorship, and internship to make your vision into reality.',

        ]}

        typeSpeed={40}

        backSpeed={20}

        loop={false}

        startDelay={3000}

        showCursor={false}

      />

    </Typography>

    <Box

      sx={{

        display: 'flex',

        flexDirection: { xs: 'column', sm: 'row' },

        gap: 2,

        justifyContent: 'center',

      }}

    >

      <div>

     

      <Button

        variant="outlined"

        size="large"

        onClick={() => setOpen(true)}

        sx={{

          background: '#010314',

          borderRadius: '100px',

          borderColor: '#9333EA',

          color: '#d8b4fe',

          '&:hover': {

            borderColor: '#7E22CE',

            bgcolor: 'rgba(147, 51, 234, 0.1)',

          },

          px: 4,

          py: 1.5,

        }}

      >

        Register for Elephant Tank

      </Button>

 

    

      <Dialog

  open={open}

  onClose={() => setOpen(false)}

  sx={{

    '& .MuiBackdrop-root': {

      backgroundColor: 'rgba(5, 6, 14, 0.8)',

    },

    '& .MuiPaper-root': {

      borderRadius: '16px',

      padding: '16px',

    },

  }}

> 

 

  <Button

    onClick={() => setOpen(false)}

    sx={{

      position: 'absolute',

      top: 8,

      right: 8,

      minWidth: 'auto',

      color: '#9333EA',

      backgroundColor: 'purple',

      '&:hover': {

        backgroundColor: 'rgba(147, 51, 234, 0.1)',

      },

    }}

  >

    ✖

  </Button>

 

  <DialogTitle

    sx={{

      textAlign: 'center',

      fontWeight: 'bold',

      color: '#9333EA',

    }}

  >

    Select Your Role

  </DialogTitle>

  <DialogContent

    sx={{

      display: 'flex',

      justifyContent: 'center',

      gap: 2,

      px: 5,

      py: 3,

    }}

  >

   

    

    

    <Button

      variant="contained"

      size="large"

      onClick={() => navigate('/StudentRegister')}

      sx={{

        background: '#9333EA',

        color: 'white',

        borderRadius: '50px',

        px: 4,

        py: 1.5,

        '&:hover': {

          bgcolor: '#7E22CE',

        },

      }}

    >

      Candidate

    </Button>

 

    <Button

      variant="contained"

      size="large"

      onClick={() => navigate('/invesRegis')}

      sx={{

        background: '#9333EA',

        color: 'white',

        borderRadius: '50px',

        px: 4,

        py: 1.5,

        '&:hover': {

          bgcolor: '#7E22CE',

        },

      }}

    >

      Investor

    </Button>

 

  </DialogContent>

</Dialog>

 

 

    </div>

      <Button

        component="a"

        href="https://innovatex.elephant-tank.com/"

        target="_blank"

        rel="noopener noreferrer"

        variant="outlined"

        size="large"

        sx={{

          background: '#010314',

          borderRadius: '100px',

          borderColor: '#9333EA',

          color: '#d8b4fe',

          '&:hover': {

            borderColor: '#7E22CE',

            bgcolor: 'rgba(147, 51, 234, 0.1)',

          },

          px: 4,

          py: 1.5,

        }}

      >

        Apply For InnovateX

      </Button>

    </Box>

  </Box> */}

 

<Box sx={{ textAlign: 'center', maxWidth: '800px', mx: 'auto', zIndex: 1 }}>

  {/* Logo Section with Continuous Animation */}

  <Box sx={{ mb: 1 }}>

   

      <Box

        component="img"

        src={DYPLogo} // Replace with your actual logo path

        alt="Logo"

        sx={{

          height: 'auto',

          maxHeight: { xs: '80px', sm: '100px', md: '120px' }, // Adjust logo size for different screen sizes

        }}

      />

  </Box>

 

 


<Swiper
      spaceBetween={30}
      slidesPerView={1}
      loop={true}
      pagination={{ clickable: true }}
      modules={[Pagination, Autoplay]}
      autoplay={{
        delay: 2000, // Delay between slides in milliseconds
        disableOnInteraction: false,
      }}
      style={{
        width: '100%',
        height: '100%',
        // backgroundColor: '#000', // Background for the entire swiper
        // padding: '20px',
      }}
    >
      {/* First Slide */}
      <SwiperSlide
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: '#fff',
          height: '100%',
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          style={{
            color: 'white',
            fontWeight: 'bold',
            marginBottom: '20px',
            fontSize: '2.5rem',
            textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',
          }}
        >
          D.Y. Patil PGDM Institute Akurdi, Pune (DYPPGDMI) presents an opportunity to turn your ideas into reality @ Elephant Tank and InnovateX events on 31st January, 2025 and 1st February 2025 at our elite Campus.

        </Typography>
        <Typography
          variant="h6"
          style={{
            color: '#e9d5ff',
            marginBottom: '30px',
            textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',
          }}
        >
          Join the Revolution and Make Your Ideas Count!
        </Typography>
      </SwiperSlide>

      {/* Second Slide */}
      <SwiperSlide
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: '#fff',
          height: '100%',
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          style={{
            color: 'white',
            fontWeight: 'bold',
            marginBottom: '20px',
            textShadow: '0 0 15px rgba(255, 165, 0, 0.8)',
          }}
        >
          Elephant Tank
        </Typography>
        <Typography
          variant="h2"
          component="h1"
          style={{
            color: 'white',
            fontWeight: 'bold',
            marginBottom: '20px',
            fontSize: '2.5rem',
            textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',
          }}
        >
          Step Into the Spotlight with Elephant Tank Your Big Ideas Deserve Big Breaks!
        </Typography>
        <Typography
          variant="h6"
          style={{
            color: '#e9d5ff',
            marginBottom: '20px',
            textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',
          }}
        >
          Bring your dreams to life with funding, expert mentorship, and much more. Whether it’s a ground-breaking Business idea or an Innovative solution, Elephant Tank is your Launchpad to success!
        </Typography>
      </SwiperSlide>

      {/* Third Slide */}
      <SwiperSlide
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: '#fff',
          height: '100%',
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          style={{
            color: 'white',
            fontWeight: 'bold',
            marginBottom: '20px',
            textShadow: '0 0 15px rgba(173, 216, 230, 0.8)',
          }}
        >
          InnovateX
        </Typography>
        <Typography
          variant="h2"
          component="h1"
          style={{
            color: 'white',
            fontWeight: 'bold',
            marginBottom: '20px',
            fontSize: '2.5rem',
            textShadow: '0 0 20px rgba(233, 85, 255, 0.8)',
          }}
        >
          Unleash Your Potential with InnovateX Where Creativity Meets Opportunity!
        </Typography>
        <Typography
          variant="h6"
          style={{
            color: '#e9d5ff',
            marginBottom: '30px',
            textShadow: '0 0 15px rgba(233, 85, 255, 0.6)',
          }}
        >
          Dive into a one-of-a-kind platform to turn your vision into impact. With mentorship, internships, and resources at your fingertips, InnovateX is your gateway to making a difference and a niche in the industry.
        </Typography>
      </SwiperSlide>
    </Swiper>

 

  <Box

    sx={{

      display: 'flex',

      flexDirection: { xs: 'column', sm: 'row' },

      gap: 2,

      justifyContent: 'center',

    }}

  >

    <div>

      {/* Main Button */}
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h4"
          sx={{
            color: '#ffd700',
            fontWeight: 'bold',
            textShadow: '0 0 15px rgba(255, 215, 0, 0.8)',
          }}
        >
           Check Out the Winners Below! 
        </Typography>
      </Box>
      {/* <Button

        variant="outlined"

        size="large"

        onClick={() =>
          handleButtonClick(
            'User Actions',
            'BannerRegister@ElephantTank',
            () => setOpen(true) 
          )
        }
        sx={{

          background: '#010314',

          borderRadius: '100px',

          borderColor: '#9333EA',

          color: '#d8b4fe',

          '&:hover': {

            borderColor: '#7E22CE',

            bgcolor: 'rgba(147, 51, 234, 0.1)',

          },

          px: 4,

          py: 1.5,

        }}

      >

        Register @ Elephant Tank

      </Button>

 


      <Dialog

        open={open}

        onClose={() => setOpen(false)}

        sx={{

          '& .MuiBackdrop-root': {

            backgroundColor: 'rgba(5, 6, 14, 0.8)', 

          },

          '& .MuiPaper-root': {

            borderRadius: '16px',

            padding: '16px',

          },

        }}

      >

        

        <Button

          onClick={() => setOpen(false)}

          sx={{

            position: 'absolute',

            top: 8,

            right: 8,

            minWidth: 'auto',

            color: '#9333EA',

            backgroundColor: 'purple',

            '&:hover': {

              backgroundColor: 'rgba(147, 51, 234, 0.1)',

            },

          }}

        >

          ✖

        </Button>

 

        <DialogTitle

          sx={{

            textAlign: 'center',

            fontWeight: 'bold',

            color: '#9333EA',

          }}

        >

          Select Your Role

        </DialogTitle>

        <DialogContent

          sx={{

            display: 'flex',

            justifyContent: 'center', 
            gap: 2, 

            px: 5,

            py: 3,

          }}

        >

          

          <Button

            variant="contained"

            size="large"

            onClick={() => navigate('/StudentRegister')} 
            sx={{

              background: '#9333EA',

              color: 'white',

              borderRadius: '50px',

              px: 4,

              py: 1.5,

              '&:hover': {

                bgcolor: '#7E22CE',

              },

            }}

          >

            Candidate

          </Button>

 

          <Button

            variant="contained"

            size="large"

            onClick={() => navigate('/invesRegis')} 

            sx={{

              background: '#9333EA',

              color: 'white',

              borderRadius: '50px',

              px: 4,

              py: 1.5,

              '&:hover': {

                bgcolor: '#7E22CE',

              },

            }}

          >

            Investor

          </Button>

        </DialogContent>

      </Dialog> */}

    </div>

    {/* <Button

      component="a"

      onClick={() => 
        handleButtonClick(
          'User Actions',
          'BannerApplyinternship',
          () => navigate('/jobformp3') 
        )
      }
            target="_blank"

      rel="noopener noreferrer"

      variant="outlined"

      size="large"

      sx={{

        background: '#010314',

        borderRadius: '100px',

        borderColor: '#9333EA',

        color: '#d8b4fe',

        '&:hover': {

          borderColor: '#7E22CE',

          bgcolor: 'rgba(147, 51, 234, 0.1)',

        },

        px: 4,

        py: 1.5,

      }}

    >

      Apply for internship @ InnovateX

    </Button> */}

  </Box>

</Box>

 {/* ///////////////////// */}
 <Box
  sx={{
    textAlign: "center",
    maxWidth: "800px",
    mx: "auto",
    mt: 4,
    zIndex: 1,
    position: "relative",
  }}
>
  <Swiper
    spaceBetween={30}
    slidesPerView={1}
    loop={true}
    pagination={{ clickable: true }}
    modules={[Pagination, Autoplay]}
    autoplay={{
      delay: 2500,
      disableOnInteraction: false,
    }}
    style={{
      width: "100%",
      height: "100%",
    }}
  >
    {/* Winner 1 Slide */}
    <SwiperSlide
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
        height: "100%",
        position: "relative",
      }}
    >
      <Particles
        id="tsparticles"
        options={particleOptions}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      />
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        style={confettiStyles}
      />
      <Box
        component="img"
        src={one}
        alt="Winner 1"
        sx={{
          width: "120%", // Increased from 100% to 120%
          height: "auto",
          borderRadius: "10px",
          mb: 2,
          boxShadow: "0 0 15px rgba(0,0,0,0.5)",
          zIndex: 1,
        }}
      />
      <Typography
        variant="h4"
        style={{
          color: "#FFD700",
          fontWeight: "bold",
          marginBottom: "10px",
          textShadow: "0 0 20px rgba(255, 215, 0, 0.8)",
          zIndex: 1,
        }}
      >
        Smart Home Automation
      </Typography>
      <Typography variant="h6" style={{ color: "#e9d5ff", zIndex: 1 }}>
        🏆 Champion - 1st Place
      </Typography>
    </SwiperSlide>

    {/* Winner 2 Slide */}
    <SwiperSlide
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
        height: "100%",
        position: "relative",
      }}
    >
      <Particles
        id="tsparticles"
        options={particleOptions}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      />
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        style={confettiStyles}
      />
      <Box
        component="img"
        src={two}
        alt="Winner 2"
        sx={{
          width: "120%", // Increased from 100% to 120%
          height: "auto",
          borderRadius: "10px",
          mb: 2,
          boxShadow: "0 0 15px rgba(0,0,0,0.5)",
          zIndex: 1,
        }}
      />
      <Typography
        variant="h4"
        style={{
          color: "#C0C0C0",
          fontWeight: "bold",
          marginBottom: "10px",
          textShadow: "0 0 20px rgba(192, 192, 192, 0.8)",
          zIndex: 1,
        }}
      >
        Customer Interaction Outsourcing
      </Typography>
      <Typography variant="h6" style={{ color: "#e9d5ff", zIndex: 1 }}>
        🥈 Champion - 2nd Place
      </Typography>
    </SwiperSlide>

    {/* Winner 3 Slide */}
    <SwiperSlide
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
        height: "100%",
        position: "relative",
      }}
    >
      <Particles
        id="tsparticles"
        options={particleOptions}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      />
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        style={confettiStyles}
      />
      <Box
        component="img"
        src={three}
        alt="Winner 3"
        sx={{
          width: "120%", // Increased from 100% to 120%
          height: "auto",
          borderRadius: "10px",
          mb: 2,
          boxShadow: "0 0 15px rgba(0,0,0,0.5)",
          zIndex: 1,
        }}
      />
      <Typography
        variant="h4"
        style={{
          color: "#CD7F32",
          fontWeight: "bold",
          marginBottom: "10px",
          textShadow: "0 0 20px rgba(205, 127, 50, 0.8)",
          zIndex: 1,
        }}
      >
        Maha Vaayu Innovations
      </Typography>
      <Typography variant="h6" style={{ color: "#e9d5ff", zIndex: 1 }}>
        🥉 Champion - 3rd Place
      </Typography>
    </SwiperSlide>

    {/* Group Photo Slide */}
    <SwiperSlide
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
        height: "100%",
        position: "relative",
      }}
    >
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        style={confettiStyles}
      />
      <Box
        component="img"
        src={four}
        alt="Group Photo"
        sx={{
          width: "120%", // Increased from 100% to 120%
          height: "auto",
          borderRadius: "10px",
          mb: 2,
          boxShadow: "0 0 15px rgba(0,0,0,0.5)",
        }}
      />
      <Typography
        variant="h4"
        style={{
          color: "#FFD700",
          fontWeight: "bold",
          marginBottom: "10px",
          textShadow: "0 0 20px rgba(255, 215, 0, 0.8)",
        }}
      >
        🎉 United as Champions 🎉
      </Typography>
      <Typography variant="h6" style={{ color: "#e9d5ff" }}>
        Together We Rise, Together We Shine! 🌟
      </Typography>
    </SwiperSlide>
  </Swiper>
</Box>




</Container>

 

</Container>

 

 

 

        {/* About Section */}

        <Container

      sx={{

        py: 5,

        background: '#010314',

        color: 'white',

        mb:3,

        zIndex:10,

      }}

    >

      

 

   

      {/* Title */}

      <Typography

        variant="h2"

        sx={{

          textAlign: 'center',

          mb: 4,

          fontSize: { xs: '2.5rem', md: '3.5rem' },

          fontWeight: 'bold',

          position: 'relative',

          '&::after': {

            content: '""',

            position: 'absolute',

            bottom: -16,

            left: '50%',

            transform: 'translateX(-50%)',

            width: 100,

            height: 4,

            background: 'linear-gradient(90deg, transparent, #361C82, transparent)',

            borderRadius: 2,

          },

        }}

      >

        About the Event

      </Typography>

 

      <Grid container spacing={6}>

        {/* Elephant Tank Section */}

       <Grid item xs={12} md={6}>

      <Box

        sx={{

          background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, rgba(102, 51, 238, 0.37) 69.34%, rgba(255, 255, 255, 0.37) 100%)',

          borderRadius: '16px',

          padding: '32px',

          boxShadow: '0px 10px 20px rgba(39, 9, 67, 0.6)',

          transition: 'transform 0.3s ease, box-shadow 0.3s ease',

          '&:hover': {

            transform: 'scale(1.02)',

            boxShadow: '0px 15px 40px rgba(39, 9, 67, 0.8)',

          },

        }}

      >

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>

          <Box

            sx={{

              width: 56,

              height: 56,

              background: 'rgba(39, 9, 67, 0.58)',

              borderRadius: '16px',

              display: 'flex',

              alignItems: 'center',

              justifyContent: 'center',

              fontSize: '2rem',

            }}

          >

            🐘

          </Box>

          <Typography

            variant="h4"

            sx={{

              fontWeight: 'bold',

              color: '#ffffff',

            }}

          >

            Elephant Tank

          </Typography>

        </Box>

 

        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>

          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1-header">

            <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

              What is Elephant Tank?

            </Typography>

          </AccordionSummary>

          <AccordionDetails>

            <Typography sx={{ color: '#e9d5ff', lineHeight: 1.8 }}>

              Elephant Tank is more than just an idea-pitching competition—it’s a launchpad for aspiring Entrepreneurs and Innovators. Unlike the traditional “Shark Tank,” this platform embodies the strength, wisdom, and nurturing spirit of the elephant, offering participants opportunities to grow and thrive through:

              <br />• Seed Funding: Access investments from industry leaders to transform your ideas into reality.

            </Typography>

          </AccordionDetails>

        </Accordion>

 

        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>

          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel2-header">

            <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

              Important Dates & Details

            </Typography>

          </AccordionSummary>

          <AccordionDetails>

            <Typography sx={{ color: '#e9d5ff' }}>

              • <b>Last Date of Registration:</b> 15th January, 2024 <br />

              • <b>Last Date of Idea Submission:</b> 20th January, 2025 <br />

              • <b>Dates for Idea Presentation:</b> 31st January, 2025 / 1st February, 2025 <br />

              • <b>Venue:</b> D Y Patil PGDM Institute, Dr. D.Y. Patil Educational Complex, Sector 29, Akurdi, Pune 411044 <br />

              • <b>Group Strength:</b> Minimum 01 to Maximum 05 students <br />

              • <b>Time:</b> 9:00 AM to 5:00 PM (Both Days) <br />

              • <b>Note:</b> No Registration Fees

            </Typography>

          </AccordionDetails>

        </Accordion>

 

        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>

          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel3-header">

            <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

              Eligibility Criteria

            </Typography>

          </AccordionSummary>

          <AccordionDetails>

            <Typography sx={{ color: '#e9d5ff' }}>

              • <b>Undergraduate Students:</b> Students from diverse fields such as BBA, B.Com, B.Sc., B.Tech/B.E., B.Arch, B.Pharm, BFA, and other streams (First to final year students). <br />

              • <b>Postgraduate Students:</b> Participants pursuing MBA, MCA, PGDM, M.Pharm, M.Tech, M.Sc., M.Arch, and other postgraduate programs.

            </Typography>

          </AccordionDetails>

        </Accordion>

 

        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>

          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel4-header">

            <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

              Prizes & Awards

            </Typography>

          </AccordionSummary>

          <AccordionDetails>

            <Typography sx={{ color: '#e9d5ff' }}>

              • <b>Cash Awards:</b> Rs. 25,000 (1st), Rs. 15,000 (2nd), Rs. 10,000 (3rd) <br />

              • <b>Recognition:</b> Winners will be awarded certificates and trophies. <br />

              • <b>Funding Opportunities:</b> Angel investors will support winning ideas. <br />

              • <b>Additional Funding:</b> Exceptional ideas beyond the top three may receive funding.

            </Typography>

          </AccordionDetails>

        </Accordion>

      </Box>

    </Grid>

 

        {/* Elephant Tank Image */}

        {/* <Grid item xs={12} md={6}>

        <Box

  component="video"

  src={v1} // Replace `v1` with the path to your video file

  alt="Elephant Tank Video"

  muted

  loop

  autoPlay

 

  sx={{

    width: '100%',

    height: 'auto',

    borderRadius: 4,

    mt:15,

    boxShadow: '4px 4px 50px 15px #361C82',

    objectFit: 'cover',

  }}

/>

 

        </Grid> */}
<Grid item xs={12} md={6}>
  <Box
    component="video"
    src={v1} // Replace `v1` with the path to your video file
    alt="Elephant Tank Video"
    muted
    loop
    autoPlay
    sx={{
      width: '100%',
      height: 'auto',
      borderRadius: 4,
      mt: 15,
      boxShadow: '4px 4px 50px 15px #361C82',
      objectFit: 'cover',
    }}
  />
</Grid>

{/* InnovateX Video */}
<Grid item xs={12} md={6}>
  <Box
    component="video"
    src={v2} // Replace `v2` with the path to your video file
    alt="InnovateX Video"
    muted
    loop
    autoPlay
    sx={{
      width: '100%',
      height: 'auto',
      borderRadius: 4,
      mt: 10,
      boxShadow: '4px 4px 50px 15px #361C82',
      objectFit: 'cover',
    }}
  />
</Grid>

 

        {/* InnovateX Image */}

        {/* <Grid item xs={12} md={6}>

        <Box

  component="video"

  src={v2} // Replace `v2` with the path to your video file

  alt="InnovateX Video"

  muted

  loop

  autoPlay

  sx={{

    width: '100%',

    height: 'auto',

    borderRadius: 4,

    mt:10,

    boxShadow: '4px 4px 50px 15px #361C82',

    objectFit: 'cover',

  }}

/>

 

        </Grid> */}

 

        {/* InnovateX Section */}

        <Grid item xs={12} md={6}>

  <Box

    sx={{

      background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, rgba(102, 51, 234, 0.37) 69.34%, rgba(255, 255, 255, 0.37) 100%)',

      borderRadius: '16px',

      padding: '32px',

      boxShadow: '0px 10px 20px rgba(39, 9, 67, 0.6)',

      transition: 'transform 0.3s ease, box-shadow 0.3s ease',

      '&:hover': {

        transform: 'scale(1.02)',

        boxShadow: '0px 15px 40px rgba(39, 9, 67, 0.8)',

      },

    }}

  >

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>

      <Box

        sx={{

          width: 56,

          height: 56,

          background: 'rgba(39, 9, 67, 0.58)',

          borderRadius: '16px',

          display: 'flex',

          alignItems: 'center',

          justifyContent: 'center',

          fontSize: '2rem',

        }}

      >

        🚀

      </Box>

      <Typography

        variant="h4"

        sx={{

          fontWeight: 'bold',

          color: '#ffffff',

        }}

      >

        InnovateX

      </Typography>

    </Box>

 

    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>

      <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1-header">

        <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

          What is InnovateX?

        </Typography>

      </AccordionSummary>

      <AccordionDetails>

        <Typography sx={{ color: '#e9d5ff', lineHeight: 1.8 }}>

        InnovateX is a unique research and POC internship initiative bridging academics with industry. It offers:      

           <br />• Mentorship: Expert guidance to refine your vision.

          <br />• Internships: Real-world exposure and career-building opportunities.

          <br />• Collaboration: Work with top companies on real challenges.

          <br />• Hands-On Experience: Develop practical research and POC skills.

          <br />• Certification: Earn globally recognized credentials to boost your profile.

        </Typography>

      </AccordionDetails>

    </Accordion>

 

    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>

      <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel2-header">

        <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

          Eligibility Criteria

        </Typography>

      </AccordionSummary>

      <AccordionDetails>

        <Typography sx={{ color: '#e9d5ff', lineHeight: 1.8 }}>

          • <b>Undergraduate Students:</b> Open to students from disciplines like BBA, B.Com, B.Sc., B.Tech/B.E., B.Arch, B.Pharm, BFA, and others. Students from the first year to the final year are welcome to test the industry waters.

          <br />• <b>Postgraduate Students:</b> Open to those pursuing programs such as MBA, MCA, PGDM, M.Pharm, M.Tech, M.Sc., M.Arch, and others.

        </Typography>

      </AccordionDetails>

    </Accordion>

 

    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>

      <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel3-header">

        <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

          Important Dates & Details

        </Typography>

      </AccordionSummary>

      <AccordionDetails>

        <Typography sx={{ color: '#e9d5ff' }}>

          • <b>Last Date of Registration:</b> 20th January, 2024 <br />

          • <b>Dates for Interview with Industry on Campus:</b> 31st January, 2025 / 1st February, 2025 <br />

          • <b>Venue:</b> D Y Patil PGDM Institute, Dr. D.Y. Patil Educational Complex, Sector 29, Akurdi, Pune 411044 <br />

          • <b>Time:</b> 9:00 AM to 5:00 PM (Both Days) <br />

          • <b>Note:</b> No Registration Fees

        </Typography>

      </AccordionDetails>

    </Accordion>

 

    <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>

      <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel4-header">

        <Typography sx={{ fontWeight: 'bold', color: '#e9d5ff' }}>

          Outcomes for InnovateX

        </Typography>

      </AccordionSummary>

      <AccordionDetails>

        <Typography sx={{ color: '#e9d5ff', lineHeight: 1.8 }}>

          • <b>Premium Internships:</b> Access to exclusive internships with leading organizations. <br />

          • <b>Skill Development:</b> Enhance practical skills and industry readiness for a competitive edge. <br />

          • <b>Networking Opportunities:</b> Build valuable connections for future career growth. <br />

          • <b>Certification of Excellence:</b> Receive official certificates recognizing contributions and learning.

        </Typography>

      </AccordionDetails>

    </Accordion>

  </Box>

</Grid>

 

 

      </Grid>

    </Container>

 

 

 

                {/* Register Now Section */}

              

<Box

  sx={{

    position: "relative",

    py: 8,

    px: 4,

    background:

      "radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)",

    overflow: "hidden",

    borderRadius: "24px",

    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",

    mx: "auto",

    maxWidth: "1200px",

    mt: 6,

  }}

> 

  <Container maxWidth="lg">

    {/* <Typography

      variant="h2"

      sx={{

        fontSize: { xs: "2rem", md: "3rem" },

        fontWeight: 600,

        color: "white",

        textAlign: "center",

        mb: 5,

        textShadow: "0 0 15px rgba(52, 7, 95, 0.5)",

      }}

    >

      Event Agenda

    </Typography> */}

<Typography

              variant="h2"

              sx={{

                color: 'white',

                textAlign: 'center',

                mb: 4,
                
                fontSize: { xs: '2.5rem', md: '3.5rem' },

                fontWeight: 'bold',

                position: 'relative',

                '&::after': {

                  content: '""',

                  position: 'absolute',

                  bottom: -16,

                  left: '50%',

                  transform: 'translateX(-50%)',

                  width: 100,

                  height: 4,

                  background: 'linear-gradient(180deg, #000000 0%, #270583 100%)',

                  borderRadius: 2,

                },

              }}

            >

              Event Agenda for Elephant Tank

            </Typography>

            <Grid container spacing={4}>

              {/* Day 1 */}

              <Grid item xs={12} md={6}>

                <Accordion

                  sx={{

                    background: "rgba(147, 51, 234, 0.15)",

                    borderRadius: "16px",

                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",

                  }}

                >

                  <AccordionSummary

                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}

                    sx={{

                      background: "#6633EE",

                      borderRadius: "12px",

                      color: "white",

                      "& .MuiAccordionSummary-content": { alignItems: "center" },

                    }}

                  >

                    <Typography

                      variant="h5"

                      sx={{

                        fontWeight: "bold",

                        textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

                      }}

                    >

                      Day 1: January 31st, 2025

                    </Typography>

                  </AccordionSummary>

                  <AccordionDetails

                    sx={{

                      color: "#e9d5ff",

                      fontSize: "1rem",

                      px: 2,

                      py: 1,

                    }}

                  >

                    {[

                      { time: "9:00 AM - 10:00 AM", event: "Onsite Registration & Approval" },

                      { time: "10:00 AM - 11:15 AM", event: "Inauguration & Welcome Address " },

                      { time: "11:15 AM - 11:45 AM", event: "Networking Break" },

                      {

                        time: "11:45 AM - 1:15 PM",

                        event: "Pitching of ideas to Investors",

                      },

                  

                      { time: "1:15 PM - 2:15 PM", event: "Lunch Break" },

                      // {

                      //   time: "2:15 PM - 3:00 PM",

                      //   event: "Panel 2 - Entrepreneurship in the Digital Age",

                      // },

                      // { time: "3:00 PM - 3:40 PM", event: "Session 2 - The Power of Networking" },

                      { time: "2:15 PM - 5:00 PM", event: "Pitching of ideas to Investors" },

                    ].map((item, index) => (

                      <Box

                        key={index}

                        sx={{

                          display: "flex",

                          alignItems: "center",

                          mb: 1.5,

                          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",

                          pb: 1,

                          ":last-of-type": { borderBottom: "none" },

                        }}

                      >

                        <Typography

                          variant="body1"

                          sx={{

                            flex: "0 0 35%",

                            fontWeight: 600,

                            color: "#D8B4FE",

                          }}

                        >

                          {item.time}

                        </Typography>

                        <Typography

                          variant="body2"

                          sx={{

                            flex: "1 1 auto",

                            color: "white",

                          }}

                        >

                          {item.event}

                        </Typography>

                      </Box>

                    ))}

                  </AccordionDetails>



                </Accordion>

              </Grid>

              {/* Day 2 */}

              <Grid item xs={12} md={6}>

                <Accordion

                  sx={{

                    background: "rgba(147, 51, 234, 0.15)",

                    borderRadius: "16px",

                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",

                  }}

                >

                  <AccordionSummary

                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}

                    sx={{

                      background: "#6633EE",

                      borderRadius: "12px",

                      color: "white",

                      "& .MuiAccordionSummary-content": { alignItems: "center" },

                    }}

                  >

                    <Typography

                      variant="h5"

                      sx={{

                        fontWeight: "bold",

                        textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

                      }}

                    >

                      Day 2: February 1st, 2025

                    </Typography>

                  </AccordionSummary>

                  <AccordionDetails

                    sx={{

                      color: "#e9d5ff",

                      fontSize: "1rem",

                      px: 2,

                      py: 1,

                    }}

                  >

                    {[

                      

                      { time: "10:00 AM - 1:30 PM", event: "Pitching of ideas to Investors" },

                      { time: "1:30 PM - 2:30 PM", event: "Lunch Break" },

                      { time: "2:30 PM - 3:30 PM", event: "Pitching of ideas to Investors" },

                      { time: "4:00 PM - 4:30 PM", event: "Valedictory Ceremony" },
                      { time: "-", event: "-" },

                  

                      // { time: "2:15 PM - 3:00 PM", event: "Panel 5 - Workforce Cross-Skilling" },

                      // { time: "3:00 PM - 3:45 PM", event: "Session 5 - AI in HR" },

                    

                    ].map((item, index) => (

                      <Box

                        key={index}

                        sx={{

                          display: "flex",

                          alignItems: "center",

                          mb: 1.5,

                          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",

                          pb: 1,

                          ":last-of-type": { borderBottom: "none" },

                        }}

                      >

                        <Typography

                          variant="body1"

                          sx={{

                            flex: "0 0 35%",

                            fontWeight: 600,

                            color: "#D8B4FE",

                          }}

                        >

                          {item.time}

                        </Typography>

                        <Typography

                          variant="body2"

                          sx={{

                            flex: "1 1 auto",

                            color: "white",

                          }}

                        >

                          {item.event}

                        </Typography>

                      </Box>

                    ))}

                  </AccordionDetails>



                </Accordion>

              </Grid>

            </Grid>

            <Typography

variant="h2"

sx={{

  color: 'white',

  textAlign: 'center',

  mb: 4,
  mt:5,
  fontSize: { xs: '2.5rem', md: '3.5rem' },

  fontWeight: 'bold',

  position: 'relative',

  '&::after': {

    content: '""',

    position: 'absolute',
    bottom: -16,

    left: '50%',

    transform: 'translateX(-50%)',

    width: 100,

    height: 4,

    background: 'linear-gradient(180deg, #000000 0%, #270583 100%)',

    borderRadius: 2,

  },

}}

>

Event Agenda for InnovateX

</Typography>

<Grid container spacing={4}>

{/* Day 1 */}

<Grid item xs={12} md={6}>

  <Accordion

    sx={{

      background: "rgba(147, 51, 234, 0.15)",

      borderRadius: "16px",

      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",

    }}

  >

    <AccordionSummary

      expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}

      sx={{

        background: "#6633EE",

        borderRadius: "12px",

        color: "white",

        "& .MuiAccordionSummary-content": { alignItems: "center" },

      }}

    >

      <Typography

        variant="h5"

        sx={{

          fontWeight: "bold",

          textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

        }}

      >

        Day 1: January 31st, 2025

      </Typography>

    </AccordionSummary>

    <AccordionDetails

      sx={{

        color: "#e9d5ff",

        fontSize: "1rem",

        px: 2,

        py: 1,

      }}

    >

      {[
 { time: "9:00 AM - 10:00 AM", event: "Onsite Registration & Approval" },

 { time: "10:00 AM - 11:15 AM", event: "Inauguration & Welcome Address " },

 { time: "11:15 AM - 11:45 AM", event: "Networking Break" },

 { time: "11:45 AM - 12:45 PM",event: "Panel 1 - From Seed to Scale: Building Sustainable Startups" },
        { time: "12:45 PM - 1:15 PM", event: "Session 1 - Digital Transformation in Business" },
        { time: "1:15 PM - 2:15 PM", event: "Lunch Break" },
        { time: "2:15 PM - 5:00 PM", event: "InnovateX Interviews" },



      ].map((item, index) => (

        <Box

          key={index}

          sx={{

            display: "flex",

            alignItems: "center",

            mb: 1.5,

            borderBottom: "1px solid rgba(255, 255, 255, 0.1)",

            pb: 1,

            ":last-of-type": { borderBottom: "none" },

          }}

        >

          <Typography

            variant="body1"

            sx={{

              flex: "0 0 35%",

              fontWeight: 600,

              color: "#D8B4FE",

            }}

          >

            {item.time}

          </Typography>

          <Typography

            variant="body2"

            sx={{

              flex: "1 1 auto",

              color: "white",

            }}

          >

            {item.event}

          </Typography>

        </Box>

      ))}

    </AccordionDetails>



  </Accordion>

</Grid>

{/* Day 2 */}

<Grid item xs={12} md={6}>

  <Accordion

    sx={{

      background: "rgba(147, 51, 234, 0.15)",

      borderRadius: "16px",

      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",

    }}

  >

    <AccordionSummary

      expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}

      sx={{

        background: "#6633EE",

        borderRadius: "12px",

        color: "white",

        "& .MuiAccordionSummary-content": { alignItems: "center" },

      }}

    >

      <Typography

        variant="h5"

        sx={{

          fontWeight: "bold",

          textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

        }}

      >

        Day 2: February 1st, 2025

      </Typography>

    </AccordionSummary>

    <AccordionDetails

      sx={{

        color: "#e9d5ff",

        fontSize: "1rem",

        px: 2,

        py: 1,

      }}

    >

      {[

        { time: "10:00 AM - 11:00 AM", event: "Panel 2 - Entrepreneurship 4.0: The Role of Digital Transformation in Business Growth" },

        { time: "11:00 AM - 11:30 AM", event: "Session 2 - People Analytics" },

        { time: "11:30 AM - 12:00 PM", event: "Networking Break" },

        { time: "12:00 PM - 1:00 PM", event: "Panel 3 - Future-Proofing Startups: Upskilling and Reskilling for Growth and Investment" },

        { time: "1:00 PM - 1:30 PM", event: "Session 3 - Preparing for Hybrid and Remote Jobs" },

        { time: "1:30 PM - 2:30 PM", event: "Lunch Break" },

        { time: "2:30 PM - 3:30 PM", event: "Internship Interviews and Selection" },



      ].map((item, index) => (

        <Box

          key={index}

          sx={{

            display: "flex",

            alignItems: "center",

            mb: 1.5,

            borderBottom: "1px solid rgba(255, 255, 255, 0.1)",

            pb: 1,

            ":last-of-type": { borderBottom: "none" },

          }}

        >

          <Typography

            variant="body1"

            sx={{

              flex: "0 0 35%",

              fontWeight: 600,

              color: "#D8B4FE",

            }}

          >

            {item.time}

          </Typography>

          <Typography

            variant="body2"

            sx={{

              flex: "1 1 auto",

              color: "white",

            }}

          >

            {item.event}

          </Typography>

        </Box>

      ))}

    </AccordionDetails>



  </Accordion>

</Grid>

</Grid>

  </Container>

</Box>

 

<Box

      sx={{

        backgroundColor: "#0f172a",

        borderRadius: "20px",

        padding: "50px",

        maxWidth: "1200px",

        margin: "50px auto",

        border: "1px solid rgba(255, 255, 255, 0.2)",

        boxShadow: "0 0 50px rgba(80, 80, 255, 0.4)",

        position: "relative",

      }}

    >

      {/* Title */}

      <Typography

        variant="h2"

        sx={{

          fontSize: { xs: "2rem", md: "3rem" },

          fontWeight: 600,

          color: "white",

          textAlign: "center",

          mb: 5,

          textShadow: "0 0 15px rgba(52, 7, 95, 0.5)",

        }}

      >

        Objectives 

      </Typography>

 

      {/* Objectives of Elephant Tank */}

      <Box

        sx={{

          display: "flex",

          flexDirection: { xs: "column", md: "row" },

          gap: "30px",

          alignItems: "flex-start",

          mb: 4,

        }}

      >

        <Box

          sx={{

            flex: 1,

            background: "linear-gradient(145deg, #4527A0, #6A1B9A)",

            padding: "30px",

            borderRadius: "16px",

            boxShadow: "0 10px 25px rgba(80, 80, 255, 0.2)",

          }}

        >

          <Typography

            variant="h5"

            sx={{

              color: "#FFFFFF",

              fontWeight: "bold",

              textTransform: "uppercase",

              mb: 2,

              textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

            }}

          >

            Objectives of Elephant Tank

          </Typography>

          <Typography

            variant="body1"

            sx={{

              color: "#E0E0E0",

              fontSize: "1.1rem",

              lineHeight: 1.8,

            }}

          >

            <ul

              style={{

                margin: 0,

                paddingLeft: "20px",

                listStyleType: "disc",

                color: "#E0E0E0",

              }}

            >

              <li>Empowering Innovation: To provide a platform for aspiring entrepreneurs to present and refine their innovative ideas, fostering creativity and practical problem-solving.</li>

              <li>Facilitating Growth: To connect participants with industry leaders, offering seed funding and mentorship to transform ideas into viable ventures.</li>

              <li>Building Entrepreneurial Ecosystems: To nurture a community of forward-thinking individuals and promote cross-disciplinary collaboration among students and professionals.</li>

            </ul>

          </Typography>

        </Box>

 

        {/* Objectives of InnovateX */}

        <Box

          sx={{

            flex: 1,

            background: "linear-gradient(145deg, #4527A0, #6A1B9A)",

            padding: "30px",

            borderRadius: "16px",

            boxShadow: "0 10px 25px rgba(80, 80, 255, 0.2)",

          }}

        >

          <Typography

            variant="h5"

            sx={{

              color: "#FFFFFF",

              fontWeight: "bold",

              textTransform: "uppercase",

              mb: 2,

              textShadow: "0 0 10px rgba(255, 255, 255, 0.5)",

            }}

          >

            Objectives of InnovateX

          </Typography>

          <Typography

            variant="body1"

            sx={{

              color: "#E0E0E0",

              fontSize: "1.1rem",

              lineHeight: 1.8,

            }}

          >

            <ul

              style={{

                margin: 0,

                paddingLeft: "20px",

                listStyleType: "disc",

                color: "#E0E0E0",

              }}

            >

              <li>Real-World Learning: To bridge the gap between academics and industry by offering students hands-on experiences through internships and projects.</li>

              <li>Skill Enhancement: To equip participants with practical skills and industry-relevant knowledge, preparing them for dynamic career opportunities.</li>

              <li>Career Development: To provide a Launchpad for students to network with professionals, explore career pathways, and build a robust foundation for future success.</li>

            </ul>

          </Typography>

        </Box>

      </Box>

    </Box>

 

 

 

{/* agenda */}

<Box

  sx={{

    position: "relative",

    py: 10,

    background:

      "radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)",

    overflow: "hidden",

    borderRadius: "24px",

    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",

    mx: "auto",

    maxWidth: "1200px",

  }}

> 

 

  <Container maxWidth="md">

    <Box sx={{ position: "relative" }}>

      <Box sx={{ textAlign: "center", position: "relative", zIndex: 2 }}>

        {/* Title */}

        <Typography

          variant="h1"

          sx={{

            fontSize: { xs: "2.5rem", md: "4.5rem" },

            fontWeight: 500,

            color: "white",

            mb: 2,

            textShadow: "0 0 20px rgba(52, 7, 95, 0.5)",

          }}

        >

          Register Now!!!

        </Typography>

 

        {/* Dynamic Date */}

        <Typography

          variant="h4"

          sx={{

            color: "#e9d5ff",

            mb: 3,

            fontWeight: "medium",

          }}

        >

          {getCurrentDate()} upto January 28, 2025 | India

        </Typography>

 

        {/* Description */}

        <Typography

          variant="h5"

          sx={{

            color: "#e9d5ff",

            mb: 3,

            maxWidth: "800px",

            mx: "auto",

            opacity: 0.8,

          }}

        >

          <Typed

            strings={[

              "Ready to make an impact? Don't miss this opportunity to showcase your talent and bring your ideas to life!",

            ]}

            typeSpeed={40}

            backSpeed={20}

            showCursor={false} // Disable cursor after animation

            loop={false} // Run the animation only once

            onComplete={() => {

              console.log("Typing animation completed");

            }}

          />

        </Typography>

 

        {/* Buttons */}

        <Box

          sx={{

            display: "flex",

            gap: 3,

            justifyContent: "center",

            flexWrap: "wrap",

          }}

        >

          <div>

      {/* Main Button */}

      <Button

        variant="outlined"

        size="large"

        // onClick={() => setOpen(true)} // Inline handler to open the dialog
        onClick={() =>
          handleButtonClick(
            'User Actions',
            'CardRegister@ElephantTank',
            () => setOpen(true) // Custom action to open the dialog
          )
        }
        sx={{

          background: '#010314',

          borderRadius: '100px',

          borderColor: '#9333EA',

          color: '#d8b4fe',

          '&:hover': {

            borderColor: '#7E22CE',

            bgcolor: 'rgba(147, 51, 234, 0.1)',

          },

          px: 4,

          py: 1.5,

        }}

      >

        Register @ Elephant Tank

      </Button>

 

      {/* Dialog */}

      <Dialog
  open={open}
  onClose={() => setOpen(false)}
  fullWidth
  maxWidth="sm" // Restrict max width for smaller screens
  sx={{
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(5, 6, 14, 0.8)', // Solid backdrop color with slight opacity
    },
    '& .MuiPaper-root': {
      borderRadius: '16px',
      padding: '16px',
      backgroundColor: 'white', // Set popup background color to white
    },
  }}
>
  {/* Close Button on Top-Right */}
  <Button
    onClick={() => setOpen(false)}
    sx={{
      position: 'absolute',
      top: 8,
      right: 8,
      minWidth: 'auto',
      color: '#9333EA',

    
    }}
  >
    ✖
  </Button>

  <DialogTitle
    sx={{
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#9333EA',
    }}
  >
    Select Your Role
  </DialogTitle>
  <DialogContent
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens, row on larger
      justifyContent: 'center', // Align buttons
      alignItems: 'center', // Center items vertically
      gap: 2, // Add spacing between buttons
      px: { xs: 2, sm: 5 }, // Responsive padding
      py: 3,
    }}
  >
    {/* Entrepreneur Button */}
    <Button
      variant="contained"
      size="large"
      // onClick={() => navigate('/StudentRegister')} // Navigate to Entrepreneur route
      onClick={() => 
        handleButtonClick(
          'User Actions',
          'CardRegister@ElephantTank',
          () => navigate('/StudentRegister') // Custom action to open the dialog
        )
      }
      // onClick={() =>
      //   handleButtonClick(
      //     'User Actions',
      //     'CardRegister@ElephantTank',
      //     () => setOpen(true) // Custom action to open the dialog
      //   )
      // }
      sx={{
        background: '#9333EA',
        color: 'white',
        borderRadius: '50px',
        px: 4,
        py: 1.5,
        width: { xs: '100%', sm: 'auto' }, // Full width on small screens
        '&:hover': {
          bgcolor: '#7E22CE',
        },
      }}
    >
      Students & Buding Entrepreneurs
    </Button>

    {/* Investor Button */}
    <Button
      variant="contained"
      size="large"
      // onClick={() => navigate('/invesRegis')} // Navigate to Investor route
      onClick={() => 
        handleButtonClick(
          'User Actions',
          'AngelInvestors&Mentors',
          () => navigate('/invesRegis') // Custom action to open the dialog
        )
      }
      sx={{
        background: '#9333EA',
        color: 'white',
        borderRadius: '50px',
        px: 4,
        py: 1.5,
        width: { xs: '100%', sm: 'auto' }, // Full width on small screens
        '&:hover': {
          bgcolor: '#7E22CE',
        },
      }}
    >
      Angel Investors & Mentors
    </Button>
  </DialogContent>
</Dialog>

 

 

 

    </div>

 

    <Button

        component="a"

        // onClick={() => navigate('/jobformp3')}
        onClick={() => 
          handleButtonClick(
            'User Actions',
            'CardApplyinternship',
            () => navigate('/jobformp3') // Custom action to open the dialog
          )
        }
        target="_blank"

        rel="noopener noreferrer"

        variant="outlined"

        size="large"

        sx={{

          background: '#010314',

          borderRadius: '100px',

          borderColor: '#9333EA',

          color: '#d8b4fe',

          '&:hover': {

            borderColor: '#7E22CE',

            bgcolor: 'rgba(147, 51, 234, 0.1)',

          },

          px: 4,

          py: 1.5,

        }}

      >

        Apply For Internship @ InnovateX

      </Button>

        </Box>

      </Box>

 

      {/* Robot Mascot */}

      <Box

        component="img"

        src={robo} // Replace with the actual image path

        alt="Robot Mascot"

        sx={{

          position: "absolute",

          right: { xs: "-100px", md: "-50px" },

          bottom: { xs: "-100px", md: "-50px" },

          width: { xs: "200px", md: "300px" },

          opacity: 0.9,

          transform: "rotate(10deg)",

          filter: "drop-shadow(0 0 20px rgba(147, 51, 234, 0.3))",

        }}

      />

    </Box>

  </Container>

</Box>

{/* impact */}

<Box

      sx={{

        backgroundColor: "#0f172a",

        borderRadius: "20px",

        padding: "50px",

        maxWidth: "1200px",

        margin: "50px auto",

        border: "1px solid rgba(255, 255, 255, 0.2)",

        boxShadow: "0 0 50px rgba(80, 80, 255, 0.4)",

        position: "relative",

      }}

    >

      {/* Title */}

      {/* <Typography

        variant="h4"

        align="center"

        sx={{

          color: "#ffffff",

          fontWeight: "bold",

          textTransform: "uppercase",

          letterSpacing: "0.2em",

          mb: 4,

          textShadow: "0px 0px 15px rgba(255, 255, 255, 0.8)",

        }}

      >

        Impact and Expected Outcomes

      </Typography> */}

      <Typography

    variant="h2"

    sx={{

      color: 'white',

      textAlign: 'center',

      mb: 4,

      fontSize: { xs: '2.5rem', md: '3.5rem' },

      fontWeight: 'bold',

      position: 'relative',

      '&::after': {

        content: '""',

        position: 'absolute',

        bottom: -16,

        left: '50%',

        transform: 'translateX(-50%)',

        width: 100,

        height: 4,

        background: 'linear-gradient(180deg, #000000 0%, #270583 100%)',

        borderRadius: 2,

      },

    }}

  >

    Impact and Expected Outcomes

  </Typography>

 

      {/* Content Section */}

      <Box

        sx={{

          background: "linear-gradient(145deg, #4527A0, #6A1B9A)",

          padding: "30px",

          borderRadius: "16px",

          boxShadow: "0 10px 25px rgba(80, 80, 255, 0.2)",

        }}

      >

        <Typography

          variant="body1"

          sx={{

            color: "#E0E0E0",

            fontSize: "1.1rem",

            lineHeight: 1.8,

            display: "flex",

            flexDirection: "column",

            gap: "15px",

          }}

        >

          <span>

            <strong>1. </strong>

            Startups gain access to fresh talent capable of contributing to

            research, development, and Proof of Concept projects.

          </span>

          <span>

            <strong>2. </strong>

            Students receive internship offers, mentorship, and the opportunity

            to work in a dynamic startup environment.

          </span>

          <span>

            <strong>3. </strong>

            Strengthening the collaboration between academia and the startup

            ecosystem, providing a platform for continuous internship

            opportunities.

          </span>

          <span>

            <strong>4. </strong>

            Creating a platform at the college for internship drives and future

            startup engagement initiatives, ensuring a sustainable system for

            talent and knowledge exchange.

          </span>

        </Typography>

      </Box>

    </Box>

{/* //why particpiate */}

<Container

  sx={{

    py: 5,

    position: 'relative',

    color: '#fff',

    background: 'radial-gradient(circle at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)',

    borderRadius: '20px',

    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',

    overflow: 'hidden',

    mt: 5,

  }}

> 

  <Typography

    variant="h2"

    sx={{

      color: 'white',

      textAlign: 'center',

      mb: 4,

      fontSize: { xs: '2.5rem', md: '3.5rem' },

      fontWeight: 'bold',

      position: 'relative',

      '&::after': {

        content: '""',

        position: 'absolute',

        bottom: -16,

        left: '50%',

        transform: 'translateX(-50%)',

        width: 100,

        height: 4,

        background: 'linear-gradient(180deg, #000000 0%, #270583 100%)',

        borderRadius: 2,

      },

    }}

  >

    Why Participate?

  </Typography>

 

  <Grid container spacing={5}>

    {[

      {

        icon: <LightbulbIcon sx={{ fontSize: 40 }} />,

        title: 'Transform Ideas into Reality',

        description: 'Pitch your innovative solutions and make a difference.',

      },

      {

        icon: <MenuBookIcon sx={{ fontSize: 40 }} />,

        title: 'Learn from the Best',

        description: 'Collaborate with industry leaders and mentors.',

      },

      {

        icon: <PublicIcon sx={{ fontSize: 40 }} />,

        title: 'Experience Real-World Innovation',

        description: 'Work on impactful projects through InnovateX',

      },

      {

        icon: <RocketLaunchIcon sx={{ fontSize: 40 }} />,

        title: 'Boost Your Career',

        description: 'Add funding, mentorship, and certifications to your portfolio.',

      },

    ].map((item, index) => (

      <Grid item xs={12} sm={6} md={3} key={index}>

        <Box

          sx={{

            borderRadius: '40px 0 40px 0', // Two sharp corners (top-right, bottom-left) and two more curved corners (top-left, bottom-right)

            background: 'linear-gradient(180deg, #000000 0%, #270583 100%)', // Gradient background

            height: '80%',

            display: 'flex',

            flexDirection: 'column',

            alignItems: 'center',

            textAlign: 'center',

            p: 4,

            color: '#fff',

            boxShadow: '4px 4px 60px 0px #8C8C8C', // Enhanced shadow for cards

          }}

        >

          <Box

            sx={{

              width: 80,

              height: 80,

              bgcolor: 'rgba(147, 51, 234, 0.2)',

              borderRadius: '50px', // Fully circular

              display: 'flex',

              alignItems: 'center',

              justifyContent: 'center',

              mb: 3,

              color: '#e9d5ff',

            }}

          >

            {item.icon}

          </Box>

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>

            {item.title}

          </Typography>

          <Typography sx={{ color: '#e9d5ff' }}>{item.description}</Typography>

        </Box>

      </Grid>

    ))}

  </Grid>

</Container>

 

        {/* Demo Video Section */}

        <Container sx={{ py: 10, position: 'relative' }}>

      <Box

        sx={{

          position: 'relative',

          width: '100%',

          maxWidth: '900px',

          mx: 'auto',

          borderRadius: 4,

          overflow: 'hidden',

          boxShadow: '10px 10px 10px 10px rgba(128, 0, 128, 0.5)', // Purple shadow

          '&::before': {

            content: '""',

            display: 'block',

            paddingTop: '56.25%', // 16:9 Aspect Ratio

          },

        }}

      >

        <Box

          component="video"

          src={sampleVideo} // Use the imported video file as the source

          controls

          sx={{

            position: 'absolute',

            top: 0,

            left: 0,

            width: '100%',

            height: '100%',

            borderRadius: 4,

            bgcolor: 'rgba(147, 51, 234, 0.1)',

          }}

        />

      </Box>

    </Container>

 

        {/* How it works   */}

    

        <Container

  sx={{

    py: 3,

    position: 'relative',

    background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, #FFFFFF 100%)',

    color: 'white',

    borderRadius: 4,

    overflow: 'hidden',

  }}

> 

  {/* Section Title */}

  <Typography

    variant="h2"

    sx={{

      textAlign: 'center',

      mb: 4,

      fontSize: { xs: '2.5rem', md: '3.5rem' },

      fontWeight: 'bold',

      position: 'relative',

      zIndex: 2,

      '&::after': {

        content: '""',

        position: 'absolute',

        bottom: -16,

        left: '50%',

        transform: 'translateX(-50%)',

        width: 100,

        height: 4,

        background: 'linear-gradient(90deg, transparent, #9333EA, transparent)',

        borderRadius: 2,

      },

    }}

  >

    How Elephant Tank Works?

  </Typography>

 

  {/* Main Content */}

  <Grid container spacing={4} alignItems="center">

    {/* Left Side: Full Image */}

    <Grid item xs={12} md={5}>

      <Box

        sx={{

          width: '100%',

          height: '100%',

          maxHeight: 500,

          display: 'flex',

          justifyContent: 'center',

          alignItems: 'center',

          overflow: 'hidden',

        }}

      >

        <img

          src={p5} // Replace with the actual image path

          alt="How it Works Illustration"

          style={{

            width: '100%',

            height: 'auto',

            objectFit: 'contain',

            borderRadius: 8,

          }}

        />

      </Box>

    </Grid>

 

    {/* Right Side: 2x2 Structure of Cards */}

    <Grid item xs={12} md={7}>

      <Grid container spacing={3}>

        {[

          {

            image: p1,

            title: 'Register Your Idea',

            description: 'Share your innovative idea or project proposal with us through our registration portal.',

          },

          {

            image: p2,

            title: 'Get Shortlisted',

            description: 'A panel of experts will evaluate submissions based on creativity, feasibility, and scalability.',

          },

          {

            image: p3,

            title: 'Pitch Your Idea',

            description: 'Present your solution to a panel of investors during Elephant Tank.',

          },

          {

            image: p4,

            title: 'Get Funded',

            description: 'Elephant Tank is your gateway to securing funding for your ideas.',

          },

        ].map((step, index) => (

          <Grid item xs={12} sm={6} key={index}>

            <Box

              sx={{

                display: 'flex',

                flexDirection: 'column',

                bgcolor: 'white',

                borderRadius: 4,

                overflow: 'hidden',

                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',

                height: '100%',

              }}

            >

              {/* Top Half: Vector Image */}

              <Box

                sx={{

                  width: '100%',

                  height: 150,

                  bgcolor: '#F8F8FF',

                  display: 'flex',

                  justifyContent: 'center',

                  alignItems: 'center',

                }}

              >

                <img

                  src={step.image} // Replace with the vector image path

                  alt={step.title}

                  style={{

                    width: '80%',

                    height: '100%',

                    objectFit: 'contain',

                  }}

                />

              </Box>

 

              {/* Bottom Half: Content */}

              <Box sx={{ p: 3, textAlign: 'center', flex: 1 }}>

                <Typography

                  variant="h6"

                  sx={{ mb: 1, color: '#1a1a1a', fontWeight: 'bold' }}

                >

                  {step.title}

                </Typography>

                <Typography

                  variant="body2"

                  sx={{ color: '#666666', lineHeight: 1.5 }}

                >

                  {step.description}

                </Typography>

              </Box>

            </Box>

          </Grid>

        ))}

      </Grid>

    </Grid>

  </Grid>

</Container>

 

 

 

        {/* FAQ Section */}

        <FAQSection />

 

        {/* Contact Section */}

        <Box

  sx={{

    background: 'linear-gradient(135deg, #6B21A8 0%, #4C1D95 100%)',

    borderRadius: '32px',

    p: { xs: 4, md: 6 },

    mx: 'auto',

    my: 10,

    maxWidth: '1200px',

    width: '90%',

    display: 'flex',

    flexDirection: { xs: 'column', md: 'row' },

    alignItems: 'flex-start', // Align items to the start

    justifyContent: 'space-between',

    gap: { xs: 4, md: 0 },

    boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.3)',

  }}

> 

  {/* Left Side */}

  <Box sx={{ flex: 1 }}>

    <Typography

      variant="h2"

      sx={{

        color: 'white',

        fontSize: { xs: '2.5rem', md: '3rem' },

        fontWeight: 'bold',

        mb: 2,

        lineHeight: '1.2',

        textAlign: 'left', // Align text to the left

      }}

    >

      Contact Us

    </Typography>

    <Typography

      sx={{

        color: 'rgba(255, 255, 255, 0.9)',

        fontSize: { xs: '1rem', md: '1.2rem' },

        maxWidth: '500px',

        textAlign: 'left', // Align text to the left

      }}

    >

      Have questions? Reach out to us at Email Address :<strong> support@elephant-tank.com</strong> or call us at{' '}

      <strong>9225584954 / 9225585835</strong>.

    </Typography>

  </Box>

 

  {/* Right Side */}

  <Box

  sx={{

    display: 'flex',

    gap: 2,

    width: { xs: '100%', md: 'auto' },

    maxWidth: { xs: '100%', md: '500px' },

    alignItems: 'center',

  }}

> 

  <TextField

    placeholder="Enter your email address..."

    variant="outlined"

    fullWidth

    sx={{

      '& .MuiOutlinedInput-root': {

        background: 'rgba(0, 0, 0, 0.8)',

        borderRadius: '50px',

        border: '2px solid rgba(255, 255, 255, 0.3)',

        '&:hover fieldset': {

          borderColor: 'rgba(255, 255, 255, 0.5)',

        },

        '&.Mui-focused fieldset': {

          borderColor: 'rgba(255, 255, 255, 0.8)',

        },

      },

      '& .MuiOutlinedInput-input': {

        py: 1.5,

        px: 3,

        color: 'white',

      },

    }}

    InputProps={{

      endAdornment: (

        <Button

          variant="contained"

          onClick={() => {

            const emailField = document.querySelector(

              '[placeholder="Enter your email address..."]'

            );

            const email = emailField?.value.trim();

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

 

            if (emailRegex.test(email)) {

              emailField.setCustomValidity('');

              window.location.href = '/StudentRegister'; // Redirects to Student Register

            } else {

              emailField.setCustomValidity('Invalid email address.');

              emailField.reportValidity();

            }

          }}

          sx={{

            background: 'linear-gradient(135deg, #9333EA, #7E22CE)',

            color: 'white',

            px: 4,

            borderRadius: '50px',

            fontWeight: 'bold',

            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',

            whiteSpace: 'nowrap',

            '&:hover': {

              background: 'linear-gradient(135deg, #7E22CE, #6B21A8)',

            },

          }}

        >

          Sign Up

        </Button>

      ),

    }}

  />

</Box>

 

</Box>
   <Footer />
<GradientBox />
</Box>

    </ThemeProvider>

  );

}
export default LandingPage;